/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type SubmitLoanApiResponse = SubmitCommonLoanApiResponse & object;

export interface SubmitCommonLoanApiResponse {
    status: LoanStatus;
    financingId?: string | null;
    externalId?: string | null;
}

export enum LoanStatus {
    NotSet = 'notSet',
    AboutToSubmit = 'aboutToSubmit',
    Review = 'review',
    Declined = 'declined',
    Prequalified = 'prequalified',
    Applied = 'applied',
    Approved = 'approved',
    NotSigned = 'notSigned',
    Rejected = 'rejected',
    Signed = 'signed',
    Error = 'error',
}

export interface ErrorInfo {
    errorCode?: string | null;
    description?: string | null;
    invalidParameter?: string | null;
    invalidValue?: string | null;
    failedSource: FailedStatusSource;
}

export enum FailedStatusSource {
    NotSet = 'notSet',
    Provider = 'provider',
    UserInput = 'userInput',
    Backend = 'backend',
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    /** @format int32 */
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions: Record<string, any>;
    [key: string]: any;
}

export type SubmitLoanApiRequest = SubmitCommonLoanApiRequest & object;

export interface SubmitCommonLoanApiRequest {
    provider: Provider;
    applicant?: ApplicantApiRequest | null;
    coApplicant?: ApplicantApiRequest | null;
    /** @format decimal */
    saleAmount?: number | null;
    /** @format decimal */
    requestedAmount: number;
    residenceOwnership: ResidenceOwnership;
    incomeSource: IncomeSource;
    /** @format decimal */
    grossMonthlyIncome: number;
    jobContext?: JobContextDto | null;
    tenantContext?: TenantContextDto | null;
    sourceContext?: SourceContextDto | null;
    userContext?: UserContextDto | null;
    extendedProperties?: ExtendedProperties | null;
    /** The name of the ServiceTitan feature that originated this loan (e.g. "Booking Confirmation", "Marketing Pro"). */
    referrer?: string | null;
    /**
     * The external identifier of the merchant account to use for this loan application.
     * When set, this MerchantId is stored on the loan and used for all post-submission provider interactions.
     */
    merchantId?: string | null;
}

export enum Provider {
    None = 'none',
    GreenSky = 'greenSky',
    ServiceFinance = 'serviceFinance',
    Turns = 'turns',
    Financeit = 'financeit',
    GoodLeap = 'goodLeap',
    WellsFargo = 'wellsFargo',
    Synchrony = 'synchrony',
    General = 'general',
    Finturf = 'finturf',
    Affirm = 'affirm',
}

export type ApplicantApiRequest = ApplicantDto & {
    /** @format date-time */
    dob?: string;
    ssn?: string | null;
};

export interface ApplicantDto {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    address?: AddressDto | null;
}

export interface AddressDto {
    street?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

export enum ResidenceOwnership {
    NotSet = 'notSet',
    Own = 'own',
    OwnWithMortgage = 'ownWithMortgage',
    Rent = 'rent',
    Other = 'other',
    LiveWithParents = 'liveWithParents',
}

export enum IncomeSource {
    NotSet = 'notSet',
    JobIncome = 'jobIncome',
    SelfEmployed = 'selfEmployed',
    Benefits = 'benefits',
    Pension = 'pension',
    SocialSecurity = 'socialSecurity',
    Disability = 'disability',
    Military = 'military',
    Student = 'student',
    Other = 'other',
}

export interface JobContextDto {
    customerId?: string | null;
    jobId?: string | null;
    address?: AddressDto | null;
    technicianId?: string | null;
    technicianName?: string | null;
    technicianEmail?: string | null;
    technicianPhone?: string | null;
}

export interface TenantContextDto {
    tenantId?: string | null;
    buId?: string | null;
}

export interface SourceContextDto {
    sourceId?: string | null;
    sourceFinancingId?: string | null;
    source: LoanApplicationSubmitSource;
}

export enum LoanApplicationSubmitSource {
    Unknown = 'unknown',
    Mobile = 'mobile',
    OnlineEstimates = 'onlineEstimates',
    Estimate = 'estimate',
    Project = 'project',
    Invoice = 'invoice',
    PrequalificationLink = 'prequalificationLink',
    Imported = 'imported',
}

export interface UserContextDto {
    ipAddress?: string | null;
    userAgent?: string | null;
}

export type ExtendedProperties = ExtendedPropertiesOfObject & object;

export type ExtendedPropertiesOfObject = Record<string, any>;

export type GetLoanApiResponse = GetCommonLoanApiResponse & {
    declineRedirectUrl?: string | null;
    /**
     * Provider-hosted URL the applicant should continue on. Distinct from declineRedirectUrl —
     * present while status may still be Review (non-terminal).
     */
    redirectUrl?: string | null;
};

export interface GetCommonLoanApiResponse {
    financingId?: string | null;
    externalId?: string | null;
    displayId?: string | null;
    provider: Provider;
    applicant?: ApplicantDto | null;
    coApplicant?: ApplicantDto | null;
    /** @format decimal */
    saleAmount?: number | null;
    /** @format decimal */
    requestedAmount: number;
    /** @format decimal */
    approvedAmount: number;
    /** @format decimal */
    availableCredit?: number | null;
    status: LoanStatus;
    rawStatus?: string | null;
    residenceOwnership: ResidenceOwnership;
    incomeSource: IncomeSource;
    jobContext?: JobContextDto | null;
    tenantContext?: TenantContextDto | null;
    sourceContext?: SourceContextDto | null;
    extendedProperties?: ExtendedProperties | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
}

export type CreateApplicationLinkApiResponse = CreateApplicationLinkBaseApiResponse & object;

export interface CreateApplicationLinkBaseApiResponse {
    /** The Financing ID */
    financingId?: string | null;
    /** The link itself taking to the provider's page. */
    applicationLink?: string | null;
    /**
     * The expiration in minutes or null if not expire
     * @format int32
     */
    expiresInMinutes?: number | null;
    /** Link delivery status */
    deliveryStatus?: string | null;
}

export type CreateApplicationLinkApiRequest = CreateApplicationLinkBaseApiRequest & {
    generalProviderName?: string | null;
};

export interface CreateApplicationLinkBaseApiRequest {
    tenantContext?: TenantContextDto | null;
    jobContext?: JobContextDto | null;
    sourceContext?: SourceContextDto | null;
    /** @format decimal */
    saleAmount?: number | null;
    /** @format decimal */
    requestedAmount: number;
    deliveryMethod: LinkDeliveryMethod;
    applicant?: ApplicantDto | null;
    /**
     * The external identifier of the merchant account to use for this loan application.
     * When set, this MerchantId is stored on the loan and used for all post-submission provider interactions.
     */
    merchantId?: string | null;
}

export enum LinkDeliveryMethod {
    NotSet = 'notSet',
    Fma = 'fma',
    CustomerPortal = 'customerPortal',
    Email = 'email',
    Text = 'text',
}

export interface LoanDocument {
    /** Type of the document. */
    documentType?: string | null;
    /** Indicates whether the primary applicant still has to submit the signature for the document. */
    primaryApplicantSignaturePending: boolean;
    /** Indicates whether the co-applicant still has to submit the signature for the document. */
    coApplicantSignaturePending: boolean;
    /** Indicates whether the dealer still has to submit the signature for the document. */
    dealerSignaturePending: boolean;
    /** Indicates whether the document needs verification. */
    needVerification: boolean;
    /** A link to download the document. */
    documentDownloadLink?: string | null;
    canSign: boolean;
    /** Alternate document download link. */
    desktopDownloadLink?: string | null;
}

export interface LoanDocumentRequest {
    loanId?: string | null;
    ipAddress?: string | null;
}

export type SignLoanDocumentRequest = LoanDocumentRequest & {
    signedDocument?: SignInfo | null;
};

export interface SignInfo {
    primaryApplicantSignature?: string | null;
    coApplicantSignature?: string | null;
}

export interface CustomerAvailableCreditResponse {
    availableCredits?: AvailableCredit[] | null;
}

export interface AvailableCredit {
    id?: string | null;
    externalId?: string | null;
    /** @format decimal */
    amount: number;
    providerName?: string | null;
    /** @format date-time */
    expirationDate?: string | null;
}

export type GetOffersApiResponseCompatible = GetOffersApiResponse & {
    offers?: OfferDtoCompatible[] | null;
};

export type OfferDtoCompatible = OfferDto & {
    /** @format decimal */
    creditLimit?: number | null;
    paymentStructure?: PaymentStructure;
    hasLowestPayment?: boolean | null;
    hasLowestRate?: boolean | null;
};

export enum PaymentStructure {
    NotSet = 'notSet',
    StandardInstallment = 'standardInstallment',
    NoInterest = 'noInterest',
    MixedInterest = 'mixedInterest',
    DeferredInterest = 'deferredInterest',
    DeferredInterestAndPrincipal = 'deferredInterestAndPrincipal',
    Promotional = 'promotional',
}

export interface OfferDto {
    id?: string | null;
    name?: string | null;
    code?: string | null;
    /** @format decimal */
    contractorFee?: number | null;
    /** @format decimal */
    approvedAmount?: number | null;
    /** @format decimal */
    availableCredit?: number | null;
    /** @format decimal */
    apr?: number | null;
    /** @format decimal */
    interestRate?: number | null;
    /** @format int32 */
    term: number;
    termUnit?: string | null;
    /** @format decimal */
    downPayment?: number | null;
    /** @format decimal */
    originationFee?: number | null;
    /** @format decimal */
    monthlyPayment?: number | null;
    /** @format decimal */
    paymentFactor?: number | null;
    autoPay?: boolean | null;
    promotion?: PromotionDto | null;
}

export interface PromotionDto {
    type?: string | null;
    details?: string | null;
}

export interface GetOffersApiResponse {
    financingId?: string | null;
    externalId?: string | null;
    selectedOfferId?: string | null;
    provider: Provider;
    status: LoanStatus;
    offers?: OfferDto[] | null;
}

export interface ApplyForOfferApiResponse {
    financingId?: string | null;
    externalId?: string | null;
    offerId?: string | null;
    provider: Provider;
    /** Might be used, might be not, will decide later */
    status: LoanStatus;
}

export interface ApplyForOfferApiRequest {
    financingId?: string | null;
    offerId?: string | null;
    userContext?: UserContextDto | null;
    /** Required for provider-specific fields */
    extendedProperties?: ExtendedProperties | null;
}

export interface GetCatalogApiResponse {
    catalogName?: string | null;
    items?: CatalogItemDto[] | null;
}

export interface CatalogItemDto {
    key?: string | null;
    displayName?: string | null;
    payload?: any;
}

export interface ImprovementType {
    name?: string | null;
    brands?: string[] | null;
    modelRequired: boolean;
}

export interface DisclosuresResponse {
    disclosures?: Disclosure[] | null;
    /** This token is used by providers to guarantee a given disclosure acceptance is not too old. */
    token?: string | null;
    /**
     * After this time the disclosure is considered old and should be invalid.
     * @format date-time
     */
    tokenExpiration: string;
}

export interface Disclosure {
    /** The category or "name" for this disclosure.  */
    category?: string | null;
    /** Text to display.  */
    text?: string | null;
    /** Whether this section should have a checkbox associated with it.  */
    checkBox: boolean;
    /** Whether this section should have a signature box associated with it. */
    signatureBox: boolean;
    /**
     * If we have multiple disclosures in this category, this determines the position of this disclosure.
     * @format int32
     */
    order: number;
}

export interface ExternalApplicationResponse {
    /** The ID by which the application is referenced in the adapter. */
    id?: string | null;
    accessLink?: string | null;
    /**
     * Used for FinanceIt: when specified, the user should be redirected to this link,
     * since there is an extra authentication step required to complete the operation.
     */
    redirectLink?: string | null;
    /**
     * Set when the request was a prequalification (soft-apply).
     * Approved means the user can proceed; Declined means the prequalification was declined.
     * Null for non-prequalification requests.
     */
    prequalificationOutcome?: PrequalificationOutcome | null;
}

export enum PrequalificationOutcome {
    Approved = 'approved',
    Declined = 'declined',
}

export interface ExternalApplicationRequest {
    providerName?: string | null;
    tenantId?: string | null;
    buId?: string | null;
    /** @format decimal */
    amount?: number | null;
    technicianId?: string | null;
    customerId?: string | null;
    source: LoanApplicationSubmitSource2;
    /** The identifier of the source of the loan application. It can be an invoice, an estimate, or a project ID. */
    sourceId?: string | null;
    jobId?: string | null;
    applicant?: Applicant | null;
    coApplicant?: Applicant | null;
    submittingUser?: SubmittingUser | null;
    planNumber?: string | null;
    state?: string | null;
    loanId?: string | null;
    /**
     * Internal prequalification Id.
     * Used in prequalification flows.
     */
    prequalId?: string | null;
    /**
     * Internal pre-approval Id.
     * Used in pre-approval (prescreen) flows.
     */
    preApprovalId?: string | null;
    /** @deprecated */
    sendEmail: boolean;
    /** If the link is to be sent to the applicant will denote the delivery method.  */
    applicantDeliveryMethod: DeliveryMethod;
    /** Indicates whether the application should be prequalified or not. */
    isPrequalification: boolean;
    /** The last four digits of the applicant's Social Security Number (SSN). */
    lastFourSSN?: string | null;
    /** Optional payment frequency for the loan. Currently only used by FinanceIt provider. */
    paymentFrequency?: PaymentFrequency | null;
    /** The external identifier of the merchant account to use for this application. */
    merchantId?: string | null;
    /**
     * The URL of the page the application was initiated from. Currently used by Affirm, which
     * URL-encodes it onto the generated Affirm prequalification (Parallel) URL for redirect-back.
     */
    referringUrl?: string | null;
}

export enum LoanApplicationSubmitSource2 {
    Unknown = 'unknown',
    Mobile = 'mobile',
    OnlineEstimates = 'onlineEstimates',
    Estimate = 'estimate',
    Project = 'project',
    Invoice = 'invoice',
    PrequalificationLink = 'prequalificationLink',
    Imported = 'imported',
}

export interface Applicant {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    address?: Address | null;
}

export interface Address {
    street?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

export interface SubmittingUser {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
}

export enum DeliveryMethod {
    None = 'none',
    Email = 'email',
    Text = 'text',
}

/** Represents the frequency of loan payments */
export enum PaymentFrequency {
    NotSet = 'notSet',
    Weekly = 'weekly',
    BiWeekly = 'biWeekly',
    Monthly = 'monthly',
}

export interface LoanApplicationRead {
    id?: string | null;
    /**
     * Internal prequalification Id.
     * Used in prequalification flows.
     */
    prequalId?: string | null;
    /**
     * The provider's own identifier for the soft-pull prequal (e.g. Service Finance's
     * SoftPullCheck ReferenceId). Distinct from ExternalLoanId and
     * ExternalPreApprovalId.
     */
    externalPrequalId?: string | null;
    /**
     * Optional back-link to a financing-owned prequal link (e.g. the prequalification link
     * that generated this application).
     */
    prequalLinkId?: string | null;
    /**
     * Provider-supplied compliance/outcome disclaimer text returned with a soft-pull
     * response. Free-form text intended for display to the applicant.
     */
    disclaimerText?: string | null;
    /**
     * Provider-supplied support/footer message (e.g. a support phone number to display
     * alongside the soft-pull outcome).
     */
    supportMessage?: string | null;
    /** Free-form provider commentary returned with a soft-pull response. */
    comments?: string | null;
    /**
     * Internal pre-approval Id.
     * Used in pre-approval (prescreen) flows.
     */
    preApprovalId?: string | null;
    /**
     * The provider's own identifier for the pre-approval (e.g. GreenSky's prescreenId).
     * Used in pre-approval (prescreen) flows.
     */
    externalPreApprovalId?: string | null;
    externalLoanId?: string | null;
    status: LoanStatus2;
    statusReason?: string | null;
    /** @deprecated */
    planNumber?: string | null;
    /** @deprecated */
    planDescription?: string | null;
    /**
     * @deprecated
     * @format int32
     */
    term?: number | null;
    /**
     * @deprecated
     * @format decimal
     */
    rate?: number | null;
    tenantId?: string | null;
    buId?: string | null;
    customerId?: string | null;
    customer?: Customer | null;
    jobId?: string | null;
    /** @format decimal */
    saleAmount: number;
    /** @format decimal */
    down: number;
    /** @format decimal */
    requestedAmount: number;
    /** @format decimal */
    approvedAmount?: number | null;
    /** @format decimal */
    payment?: number | null;
    hasCoApplicant: boolean;
    providerName?: string | null;
    source: LoanApplicationSubmitSource2;
    /** The identifier of the source of the loan application. It can be an invoice, an estimate, or a project ID. */
    sourceId?: string | null;
    /** The name of the ServiceTitan feature that originated this loan (e.g. "Booking Confirmation", "Marketing Pro"). */
    referrer?: string | null;
    technicianId?: string | null;
    /** @deprecated */
    primaryApplicantLastName?: string | null;
    improvement?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    promotionDetails?: string | null;
    creditProduct?: string | null;
    isCounterOffer: boolean;
    /** @format int32 */
    promotionPeriod: number;
    isDeferred: boolean;
    applicantEmail?: string | null;
    /** The lender (sometimes referred to as "partner" in the UI) that funds the loan. */
    lender?: string | null;
    merchantReferenceNumber?: string | null;
    isCtaRequired: boolean;
    productDisclosure?: string | null;
    primaryApplicantActivation?: Activation | null;
    coApplicantActivation?: Activation | null;
    /** @format date-time */
    appliedOn: string;
    /** @format date-time */
    expiresOn?: string | null;
    /** @format decimal */
    availableCredit?: number | null;
    creditCardUid?: string | null;
    chargeInfo?: ChargeInfo | null;
    isValid: boolean;
    trainingMessage?: string | null;
    stipulations?: Stipulation[] | null;
    referenceNumber?: string | null;
    expirationDate?: string | null;
    trainingAvailable: boolean;
    trainingUrl?: string | null;
    showTrainingAlert: boolean;
    /** @format date-time */
    lastError?: string | null;
    /** @format int32 */
    errorCount?: number | null;
    applicantDeliveryMethod?: string | null;
    /** The previous loan status, used for state change detection by Kafka consumers.  */
    previousStatus?: LoanStatus2 | null;
    /** The list of authorizations (where applicable) for the loan/revolving account. */
    authorizations?: LoanAuthorization[] | null;
    /**
     * Deprecated. Use Authorizations instead. Returns the first authorization in the list, if any.
     * Setting this value replaces the first element or adds one if the list is empty.
     * @deprecated
     */
    authorization?: LoanAuthorization | null;
    /** Masked Account Number, assigned by the provider */
    displayAccountNumber?: string | null;
    /** A series of tasks possible to execute on a loan application. */
    tasks?: LoanTask[] | null;
    /** Indicates whether any task is needed (not completed). */
    hasOutstandingTasks: boolean;
    plan?: Plan | null;
    address?: AddressDto | null;
    /** The primary applicant's information */
    primaryApplicant?: LoanApplicant | null;
    lastAuditRecord?: AuditRecord | null;
    /** The origin source from the initial context */
    originSource?: string | null;
    /** Indicates if this is a test or demo tenant from the initial context */
    isTestOrDemo?: boolean | null;
    /** The external identifier of the merchant account associated with this loan application. */
    merchantId?: string | null;
}

export enum LoanStatus2 {
    NotSet = 'notSet',
    AboutToSubmit = 'aboutToSubmit',
    Declined = 'declined',
    Approved = 'approved',
    Review = 'review',
    Signed = 'signed',
    Error = 'error',
    Invalid = 'invalid',
    CounterOffer = 'counterOffer',
    NotSigned = 'notSigned',
    ActivationRequested = 'activationRequested',
    Submitted = 'submitted',
    Cancelled = 'cancelled',
    Expired = 'expired',
    Conditional = 'conditional',
    Prequalified = 'prequalified',
    PrequalificationPending = 'prequalificationPending',
}

export interface Customer {
    customerId?: string | null;
    name?: string | null;
}

export interface Activation {
    activationStatus: ActivationStatus;
    activationMethod: ActivationMethod;
}

export enum ActivationStatus {
    NotSet = 'notSet',
    Pending = 'pending',
    Activated = 'activated',
    NotActivated = 'notActivated',
}

export enum ActivationMethod {
    Email = 'email',
    Phone = 'phone',
    EmailPhone = 'emailPhone',
}

export interface ChargeInfo {
    available: boolean;
    reasonCode?: string | null;
}

export interface Stipulation {
    id?: string | null;
    name?: string | null;
    description?: string | null;
    status?: string | null;
    appliesTo?: string | null;
}

/** Will capture the authorization (where applicable) for the loan/revolving account */
export interface LoanAuthorization {
    authorizationId?: string | null;
    /** @format decimal */
    amount: number;
    /** @format date-time */
    requestedAt: string;
    /** @format date-time */
    updatedAt?: string | null;
    status: AuthorizationStatus;
}

export enum AuthorizationStatus {
    None = 'none',
    Pending = 'pending',
    Confirmed = 'confirmed',
    Declined = 'declined',
    Voided = 'voided',
    Completed = 'completed',
}

export interface LoanTask {
    /** The type of task */
    type: TaskType;
    /** A url for that action if applicable */
    url?: string | null;
    /** If the action is completed or not */
    isCompleted: boolean;
    /**
     * The amount associated with this task
     * @format decimal
     */
    amount?: number | null;
    /** Optional identifier for the related entity this task refers to (for example, an authorization id). */
    referenceId?: string | null;
    /** @format date */
    createdOn?: string | null;
    /** @format date */
    completedOn?: string | null;
    status?: string | null;
    subTasks?: LoanTask[] | null;
    /** Calculated label based on CreatedOn and Amount */
    label?: string | null;
}

export enum TaskType {
    NotSet = 'notSet',
    UploadConditions = 'uploadConditions',
    UploadHic = 'uploadHic',
    AddProjectInfo = 'addProjectInfo',
    FinalizeLoanDetails = 'finalizeLoanDetails',
    AuthorizePayment = 'authorizePayment',
    SendSalesSlip = 'sendSalesSlip',
    CustomerSignature = 'customerSignature',
    AcceptOffer = 'acceptOffer',
    AuthorizeLoan = 'authorizeLoan',
    SendAccountActivation = 'sendAccountActivation',
    CompleteAccountActivation = 'completeAccountActivation',
    NtpCompleted = 'ntpCompleted',
    Authorize = 'authorize',
    CreateSalesSlip = 'createSalesSlip',
    SettleSalesSlip = 'settleSalesSlip',
    ActionRequired = 'actionRequired',
    FundRequest = 'fundRequest',
}

/** Defines a financing plan. */
export interface Plan {
    /** Plan number */
    planNumber?: string | null;
    /** Plan type. */
    type?: string | null;
    /** Plan description. */
    description?: string | null;
    /** Plan APR */
    apr?: string | null;
    /** Estimated payment factor showing the factor percentage or the promo factor percentage along with the factor one. */
    estimatedPaymentFactor?: string | null;
    /**
     * Plan term in months
     * @format int32
     */
    term?: number | null;
    /**
     * Contractor fee
     * @format decimal
     */
    contractorFee?: number | null;
    /**
     * Promo payment, if any
     * @format decimal
     */
    promoPayment?: number | null;
    /**
     * Promo months, if any
     * @format int32
     */
    promoMonths?: number | null;
    /**
     * Normal payment in USD
     * @format decimal
     */
    normalPayment?: number | null;
    /**
     * Normal months
     * @format int32
     */
    normalMonths?: number | null;
    /**
     * Minimum financing amount.
     * @format decimal
     */
    minAmount?: number | null;
    /**
     * Maximum financing amount.
     * @format decimal
     */
    maxAmount?: number | null;
    /** Amortizations available for each plan, used by financeit */
    amortizations?: number[] | null;
    /** Disclaimer associated with the plan. */
    disclaimerText?: string | null;
    /** The time window in months that the customer typically has to make a purchase after approved for a loan. */
    purchaseWindowMonths?: string | null;
    /** Selected amortization period for the loan. Currently only used by FinanceIt provider. */
    amortization?: string | null;
    /** Selected payment frequency for the loan. Currently only used by FinanceIt provider. */
    paymentFrequency?: string | null;
}

export interface LoanApplicant {
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    /** @format date-time */
    dateOfBirth: string;
    ssn?: string | null;
    emailAddress?: string | null;
    primaryPhone?: string | null;
    alternatePhone?: string | null;
    workPhone?: string | null;
    isMarried?: boolean | null;
    housingType: ResidenceOwnership2;
    /** @format decimal */
    monthlyHousingPayment: number;
    propertyType: PropertyType;
    address?: Address | null;
    applicantId?: LoanApplicantIdDocument | null;
    employment?: ApplicantEmployment | null;
    /** phone or email required only for WI */
    spouseContact?: string | null;
    /** @format decimal */
    annualIncome: number;
    residenceType: ResidenceType;
    employmentStatus: EmploymentStatus;
    citizenship: Citizenship;
    isUSCitizen?: boolean | null;
    spokenLanguage: SpokenLanguage;
    /** A base64 encoded signature of the applicant. */
    signature?: string | null;
    spouse?: Spouse | null;
}

export enum ResidenceOwnership2 {
    NotSet = 'notSet',
    Own = 'own',
    Rent = 'rent',
    OwnWithMortgage = 'ownWithMortgage',
    LiveWithParents = 'liveWithParents',
}

export enum PropertyType {
    NotSet = 'notSet',
    SingleFamily = 'singleFamily',
    ManufacturedHome = 'manufacturedHome',
}

export interface LoanApplicantIdDocument {
    applicantIdDocumentType: LoanApplicantIdDocumentType;
    documentId?: string | null;
    state?: string | null;
    country?: string | null;
    /** @format date-time */
    issueDate: string;
    /** @format date-time */
    expirationDate: string;
    issuerName?: string | null;
    governmentBranch?: string | null;
}

export enum LoanApplicantIdDocumentType {
    NotSet = 'notSet',
    MilitaryId = 'militaryId',
    DriversLicense = 'driversLicense',
    StateId = 'stateId',
    Passport = 'passport',
    UsaGreenCard = 'usaGreenCard',
    Visa = 'visa',
    Other = 'other',
}

export interface ApplicantEmployment {
    /** @format decimal */
    grossMonthlyIncome: number;
    employerName?: string | null;
    employerPhone?: string | null;
}

export enum ResidenceType {
    NotSet = 'notSet',
    Primary = 'primary',
    Secondary = 'secondary',
    Investment = 'investment',
}

export enum EmploymentStatus {
    NotSet = 'notSet',
    Employed = 'employed',
    Retired = 'retired',
    NotEmployed = 'notEmployed',
    Other = 'other',
}

export enum Citizenship {
    NotSet = 'notSet',
    USCitizen = 'usCitizen',
    LawfulPermanentResident = 'lawfulPermanentResident',
    Other = 'other',
}

export enum SpokenLanguage {
    NotSet = 'notSet',
    English = 'english',
    Spanish = 'spanish',
    Other = 'other',
}

export interface Spouse {
    firstName?: string | null;
    lastName?: string | null;
    address?: Address | null;
}

/**
 * Audit Record that will be published with each change saved to the load application in DB.
 * Example record - When: date, Type: 'Decision', SubtType: 'Approved', Amount: null, AvailabeCredit: null,
 * Example record - When: date, Type: 'Authorization', SubtType: 'Requested', Amount: 5000, AvailabeCredit: 10000
 * Example record - When: date, Type: 'Authorization', SubtType: 'Approved', Amount: 5000, AvailabeCredit: 5000 (reduced due to captured auth)
 * Example record - When: date, Type: 'Charge', SubtType: 'Requested', Amount: 5000, AvailabeCredit: 5000 (not reduced since its charging authed amount)
 * Example record - When: date, Type: 'Charge', SubtType: 'Approved', Amount: 5000, AvailabeCredit: 5000 not reduced since its charging authed amount, or for some providers
 * like greensky it will be reduced since authing and charging is done in one shot)
 */
export interface AuditRecord {
    /** What happened on the loan. */
    type: AuditEventType;
    /** Additional info when applicable */
    subType: AuditEventSubType;
    /**
     * When it happened
     * @format date-time
     */
    when: string;
    /**
     * not null when relevant (like auth or charge)
     * @format decimal
     */
    amount?: number | null;
    /**
     * Always show the updated available credit
     * @format decimal
     */
    availableCredit?: number | null;
    /** Human-readable description of what changed */
    changeDescription?: string | null;
}

export enum AuditEventType {
    NotSet = 'notSet',
    Decision = 'decision',
    Signature = 'signature',
    Authorization = 'authorization',
    Charge = 'charge',
    ChangeOrder = 'changeOrder',
    OfferDetails = 'offerDetails',
    Metadata = 'metadata',
    Workflow = 'workflow',
}

export enum AuditEventSubType {
    NotSet = 'notSet',
    Pending = 'pending',
    Approved = 'approved',
    Rejected = 'rejected',
}

export interface ChangeExternalOrderRequest {
    providerName?: string | null;
    tenantId?: string | null;
    businessUnitId?: string | null;
    loanId?: string | null;
    amount?: InternationalPayment | null;
    planNumber?: string | null;
}

export interface InternationalPayment {
    /** Currency symbol. Example: "USD" */
    type?: string | null;
    /**
     * Amount of payment
     * @format decimal
     */
    value: number;
}

export type Operation = OperationBase & {
    value?: any;
};

export interface OperationBase {
    path?: string | null;
    op?: string | null;
    from?: string | null;
}

export interface PublishLoanApplicationsRequest {
    loanIds?: string[] | null;
    tenantIds?: string[] | null;
    /**
     * Optional start of the date range. Must be used together with EndDate.
     * When provided, publishes loans created within the specified date range.
     * Can be combined with TenantIds and other filters.
     * @format date-time
     */
    startDate?: string | null;
    /**
     * Optional end of the date range. Must be used together with StartDate.
     * @format date-time
     */
    endDate?: string | null;
    /**
     * Optional filter by loan statuses. When provided, only loans matching one of the specified statuses are published.
     * Applies to TenantIds and date-range query paths.
     */
    statuses?: LoanStatus2[] | null;
    /**
     * Optional filter by provider name (e.g. "GreenSky", "Synchrony").
     * Applies to TenantIds and date-range query paths.
     */
    providerName?: string | null;
    /**
     * Optional filter by customer ID.
     * Applies to TenantIds and date-range query paths.
     */
    customerId?: string | null;
    /**
     * Optional filter by job ID.
     * Applies to TenantIds and date-range query paths.
     */
    jobId?: string | null;
    /**
     * Optional filter by technician ID.
     * Applies to TenantIds and date-range query paths.
     */
    technicianId?: string | null;
    /**
     * Optional filter by business unit ID.
     * Applies to TenantIds and date-range query paths.
     */
    buId?: string | null;
    /**
     * Optional filter by prequalification ID.
     * Applies to TenantIds and date-range query paths.
     */
    prequalId?: string | null;
    /**
     * Optional batch size for paginated database queries. Defaults to 2000 if not provided.
     * @format int32
     */
    batchSize?: number | null;
}

export interface ImportLoanSearchRequestDto {
    loanSearchContext?: LoanSearchContextDto | null;
    loanSearchFilters?: LoanSearchFiltersDto | null;
    providerName?: string | null;
    tenantId?: string | null;
    buId?: string | null;
}

export interface LoanSearchContextDto {
    customerId?: string | null;
    jobId?: string | null;
    source: LoanApplicationSubmitSource2;
    technicianId?: string | null;
}

export interface LoanSearchFiltersDto {
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    ssnLast4Digits?: string | null;
    zipCode?: string | null;
    externalLoanId?: string | null;
}

export interface PutProjectsRequest {
    primaryProjectType?: string | null;
    projects?: Project[] | null;
}

export interface Project {
    type?: ProjectTypeItem | null;
    isPrimary: boolean;
    details?: ProjectDetail[] | null;
}

export interface ProjectTypeItem {
    label?: string | null;
    value?: string | null;
}

export interface ProjectDetail {
    code?: string | null;
    label?: string | null;
    values?: ProjectItem[] | null;
}

export interface ProjectItem {
    name?: string | null;
    value?: string | null;
}

export interface ProjectType {
    type?: string | null;
    name?: string | null;
    inputs?: ProjectTypeInput[] | null;
    validation?: string | null;
}

export interface ProjectTypeInput {
    code?: string | null;
    label?: string | null;
    description?: string | null;
    fieldType?: string | null;
    items?: ProjectItem[] | null;
}

export type TenantAccountRead = TenantAccountBase & {
    tenantId?: string | null;
    /** @format date-time */
    updatedAt?: string;
    updatedByUserId?: string | null;
};

export interface TenantAccountBase {
    /** Name of the financing provider for which this account is used. */
    providerName?: string | null;
    /** Applicable only for general providers when ProviderName is "General" this should be set otherwise ignored for strategic providers. */
    generalProviderName?: string | null;
    /**
     * The "type" of provider, if applicable.
     * Used, for example, when provider is a "general" provider.
     */
    providerType?: string | null;
    /**
     * The financing account that will be used by default for all business units, unless another account
     * is set for a specific business unit.
     */
    defaultAccount: Account;
    /** Financing account overrides for specific business units. */
    busAccounts?: BusAccount[] | null;
    /**
     * Email where Financeit should send notifications when a new loan application is submitted.
     * Used only for Financeit.
     */
    contactEmails?: string[] | null;
    /** Property bag for storing provider-specific information. */
    properties?: Record<string, string>;
    /** Business units for which this provider is disabled for the tenant. */
    disabledBUs?: string[] | null;
}

/** A generic financing account data. */
export interface Account {
    /**
     * Financing provider's account ID for the tenant.
     * @minLength 1
     */
    externalId: string;
    /** Dealer name, used today only for Service Finance accounts. */
    dealerName?: string | null;
    /** Optional list of merchant-level sub-accounts within this financing provider account. */
    merchantAccounts?: MerchantAccount[] | null;
}

export interface MerchantAccount {
    merchantId?: string | null;
    name?: string | null;
    isDefault: boolean;
}

export interface BusAccount {
    /** Tenant's account with the provider for specific business units. */
    account?: Account | null;
    /** Business units to which this account applies. */
    businessUnits?: string[] | null;
}

export type FinanceItTenantAccountWrite = FinanceItTenantAccount & object;

/**
 * All The Financeit* classes in the Accounts folder are duplicated because of extra complexity for swagger to have proper type
 * definitions for class hierarchy (immature support in swashbuckle and nswag for open API 3.0 spec).
 */
export interface FinanceItTenantAccount {
    tenantId?: string | null;
    providerName?: string | null;
    /**
     * The financing account that will be used by default for all business units, unless another account
     * is set for a specific business unit.
     */
    defaultAccount: FinanceitAccount;
    /** Financing account overrides for specific business units. */
    busAccounts?: FinanceitBusAccount[] | null;
    /**
     * Email where Financeit should send notifications when a new loan application is submitted.
     * Used only for Financeit.
     */
    contactEmails?: string[] | null;
    /** Business units for which this provider is disabled for the tenant. */
    disabledBUs?: string[] | null;
}

/** Financeit requires an email associated with the partner account */
export type FinanceitAccount = Account & {
    /**
     * Email where Financeit should send notifications when a new loan application is submitted.
     * @minLength 1
     */
    email: string;
};

/**
 * All The Financeit* classes in the Accounts folder are duplicated because of extra complexity for swagger to have proper type
 *            definitions for class hierarchy (immature support in swashbuckle and nswag for open API 3.0 spec).
 *
 */
export interface FinanceitBusAccount {
    /** Tenant's account with the provider for specific business units. */
    account: FinanceitAccount;
    /** Business units to which this account applies. */
    businessUnits: string[];
}

export type TenantAccountWrite = TenantAccountBase & object;

export interface PublishAllAccountsResponse {
    providerName?: string | null;
    /** @format int32 */
    exportedAccountsCount: number;
}

export interface CustomerAuthChallengeStatus {
    /** The identifier for this challenge, assigned by the provider. */
    challengeId?: string | null;
    /**
     * The approximate time at which the challenge will expire.
     * @format date-time
     */
    validUntilUtc: string;
    /**
     * The number of seconds until another challenge can be started.
     * @format int32
     */
    cooldownInSeconds: number;
    /** The status of the challenge. */
    status: CustomerAuthCodeChallengeState;
}

/** Represents the possible states of an authentication code challenge. */
export enum CustomerAuthCodeChallengeState {
    NotSet = 'notSet',
    Initiated = 'initiated',
    Invalid = 'invalid',
    Completed = 'completed',
    ExpiredOrFailed = 'expiredOrFailed',
}

export type AuthenticationChallengeStartRequest = BusinessUnitRequest & {
    /** The ReCaptcha token sent by the client. */
    captchaToken?: string | null;
    /** The phone number of the applicant. */
    phone?: string | null;
    /** The email of the applicant. */
    email?: string | null;
    /** Extra metadata sent by the client. */
    metadata?: Record<string, string>;
};

export type BusinessUnitRequest = TenantProviderRequest & {
    buId?: string | null;
};

export interface TenantProviderRequest {
    providerName?: string | null;
    generalProviderName?: string | null;
    tenantId?: string | null;
}

export type AuthenticationChallengeCompleteRequest = BusinessUnitRequest & {
    /** The identifier for the challenge, assigned by the provider. */
    challengeId?: string | null;
    /** The pin entered by the user. */
    pin?: string | null;
};

export interface FindOneCustomerResponse {
    customerId?: string | null;
}

export interface FindOneCustomerRequest {
    tenantId?: string | null;
    name?: string | null;
    phone?: string | null;
    address?: Address | null;
}

export interface GetCustomerDetailsResponse {
    /** One entry per requested CustomerId, in request order. */
    customers?: CustomerDetailsDto[] | null;
}

export interface CustomerDetailsDto {
    customerId?: string | null;
    /** False when an active customer for this ID couldn't be found. */
    found: boolean;
    /** Raw CRM single-string name. */
    name?: string | null;
    /** Best-effort first/last split; lossy. */
    firstName?: string | null;
    lastName?: string | null;
    address?: Address | null;
    /** Meaningful only when Found is true; defaults to Unknown on not-found entries. */
    type: CustomerType;
}

export enum CustomerType {
    Unknown = 'unknown',
    Residential = 'residential',
    Commercial = 'commercial',
}

export interface CustomerFinancingLinkDto {
    id?: string | null;
    shortCode?: string | null;
    link?: string | null;
    provider: Provider;
    jobContext?: JobContextDto | null;
    tenantContext?: TenantContextDto | null;
    sourceContext?: SourceContextDto | null;
    /**
     * Authentication token for accessing financing endpoints from an MFE.
     * Only populated for unauthenticated link retrieval requests.
     */
    authToken?: string | null;
}

/** Request new link to Loan Application form in MFE for customer */
export interface CreateCustomerFinancingLinkApiRequest {
    provider: Provider;
    jobContext?: JobContextDto | null;
    tenantContext?: TenantContextDto | null;
    sourceContext?: SourceContextDto | null;
}

/** Links, generated for customer to apply for financing */
export interface GetCustomerFinancingLinksResponse {
    links?: CustomerFinancingLinkDto[] | null;
}

export interface SubmitApplicationResult {
    /** The unique identifier of the Loan in Financing. */
    loanId?: string | null;
    /** The unique identifier of the loan in the external provider. */
    externalLoanId?: string | null;
    /** The loan application submission, such as "Declined" or "Approved": */
    decision: SubmitApplicationDecision;
    /** The identifier of the loan plan the submission was made for. */
    planNumber?: string | null;
    /** Loan description, such as "5 year - 7.49% without Autopay" */
    description?: string | null;
    /** Plan type information, such as "Standard Installment" */
    planType?: string | null;
    /**
     * How much the loan has been approved for.
     * @format decimal
     */
    approvedAmount?: number | null;
    /**
     * How many installments the plan has.
     * @format int32
     */
    term?: number | null;
    /**
     * APR for the plan.
     * @format decimal
     */
    rate?: number | null;
    /**
     * Monthly payment for the plan.
     * @format decimal
     */
    payment?: number | null;
    /**
     * How much credit the provider is willing to extend.
     * @format decimal
     */
    maxCreditAmount?: number | null;
}

export enum SubmitApplicationDecision {
    NotSet = 'notSet',
    Invalid = 'invalid',
    Approved = 'approved',
    Declined = 'declined',
    Review = 'review',
    Error = 'error',
    CounterOffer = 'counterOffer',
    Authorized = 'authorized',
    Submitted = 'submitted',
    Cancelled = 'cancelled',
    Expired = 'expired',
}

export interface LoanApplication {
    /**
     * Internal ID of the loan.
     * This value can only be read; it cannot be set or modified.
     */
    loanId?: string | null;
    /**
     * Internal prequalification Id.
     * Used in prequalification flows.
     */
    prequalId?: string | null;
    /**
     * The provider's own identifier for the soft-pull prequal (e.g. Service Finance's
     * SoftPullCheck ReferenceId). Distinct from ExternalLoanId and
     * ExternalPreApprovalId.
     */
    externalPrequalId?: string | null;
    /**
     * Optional back-link to a financing-owned prequal link (e.g. the prequalification link
     * that generated this application).
     */
    prequalLinkId?: string | null;
    /**
     * Provider-supplied compliance/outcome disclaimer text returned with a soft-pull
     * response. Free-form text intended for display to the applicant.
     */
    disclaimerText?: string | null;
    /**
     * Provider-supplied support/footer message (e.g. a support phone number to display
     * alongside the soft-pull outcome).
     */
    supportMessage?: string | null;
    /** Free-form provider commentary returned with a soft-pull response. */
    comments?: string | null;
    /**
     * Internal pre-approval Id.
     * Used in pre-approval (prescreen) flows.
     */
    preApprovalId?: string | null;
    /**
     * The provider's own identifier for the pre-approval (e.g. GreenSky's prescreenId).
     * Used in pre-approval (prescreen) flows.
     */
    externalPreApprovalId?: string | null;
    /** Business unit for which this loan is created. */
    buId?: string | null;
    tenantId?: string | null;
    /** If applicable, the ID of the job associated with this loan. */
    jobId?: string | null;
    /** If applicable, the ID of the technician who helped submit this loan. */
    technicianId?: string | null;
    /** If applicable, the ID of the customer applying for this loan. */
    customerId?: string | null;
    /**
     * Total sale amount before the down payment.
     * @format decimal
     */
    salesAmount: number;
    /**
     * Down payment on the sale.
     * @format decimal
     */
    downPayment: number;
    /**
     * The amount requested to be borrowed.
     * @format decimal
     */
    requestedAmount: number;
    planNumber?: string | null;
    improvement?: string | null;
    address?: Address | null;
    /** Personal details of the primary applicant. */
    primaryApplicant?: LoanApplicant | null;
    /** Personal details of the co-applicant. Leave empty if there is no co-applicant. */
    coApplicant?: LoanApplicant | null;
    /** The name of the provider that is providing the loan. */
    providerName?: string | null;
    /** Helps track where this loan application was submitted from. Default: Unknown. */
    source: LoanApplicationSubmitSource2;
    /** The identifier of the source of the loan application. It can be an invoice, an estimate, or a project ID. */
    sourceId?: string | null;
    /**
     * The name of the ServiceTitan feature that originated this loan (e.g. "Booking Confirmation", "Marketing Pro").
     * Typically carried over from the prequalification link that led to this application.
     */
    referrer?: string | null;
    fingerPrint?: string | null;
    /** @format date-time */
    appliedOn: string;
    /** @format date-time */
    expiresOn?: string | null;
    /** @format decimal */
    availableCredit?: number | null;
    referenceNumber?: string | null;
    technicianLastName?: string | null;
    technicianPhone?: string | null;
    technicianEmail?: string | null;
    propertyType: PropertyType;
    /** @format decimal */
    mortgageBalance: number;
    /** @format decimal */
    mortgagePayment: number;
    disclosureToken?: string | null;
    /** A multi-value dictionary of specific provider parameters. */
    providerParameters?: Record<string, string[]>;
    /** Masked Account Number, assigned by the provider */
    displayAccountNumber?: string | null;
    /**
     * Optional. Sometimes, some providers (e.g. GreenSky) may provide a counter-offer for a plan
     * that's not listed in their Plans API. In this case, if we want to store the plan details in
     * the DB, they'll need to be provided via this field.
     */
    customPlan?: Plan | null;
    /** The external identifier of the merchant account associated with this loan application. */
    merchantId?: string | null;
}

/**
 * Response body for POST /v1/loans/prequal (FIN-17539 REQ-LIFE-02).
 *
 *  carries the provider's symbolic outcome as the shared
 *  enum (e.g. ,
 * ). This used to be emitted as a string to avoid a package
 * cycle with Prequalifications.Api.Models; that dependency is gone (FIN-17542), so it
 * is now the typed enum directly.
 */
export interface SubmitPrequalResponse {
    /**
     * The financing-internal loan application id created for this prequal (this row
     * carries a non-null PrequalId, which distinguishes it from a hard-pull row).
     */
    loanId?: string | null;
    /**
     * The provider's outcome as the shared LoanStatus enum (e.g.
     * Prequalified, Declined).
     */
    status: LoanStatus2;
    /** Provider-supplied title/headline for the outcome (e.g. "Approved!"). */
    title?: string | null;
    /** Provider-supplied compliance/outcome disclaimer text to display to the applicant. */
    disclaimerText?: string | null;
    /** Provider-supplied support/footer message (e.g. a support phone number). */
    supportMessage?: string | null;
    /** Free-form provider commentary. */
    comments?: string | null;
    /** The provider's own identifier for the soft-pull (SFC's ReferenceId, etc). */
    externalPrequalId?: string | null;
    /**
     * The amount the applicant was prequalified for, if any.
     * @format decimal
     */
    approvedAmount?: number | null;
}

/**
 * Body of POST /v1/loans/prequal — the inline soft-pull prequal endpoint
 * (FIN-17539 REQ-LIFE-02). Applicant fields are flat and mirror the shared
 * SoftPullCheckRequest so the handler can translate them directly.
 *
 * None of the PII fields (Ssn, DateOfBirth, GrossMonthlyIncome, Address) land on
 * the persisted  — only the first/last name are copied
 * to the row per REQ-LIFE-05.
 */
export interface SubmitPrequalRequest {
    /**
     * Name of the provider that should perform the soft-pull; must parse to a value of
     * the internal ProviderNames enum (e.g. "ServiceFinance").
     */
    providerName?: string | null;
    tenantId?: string | null;
    buId?: string | null;
    /** Optional back-link to a financing-owned prequal link that initiated this request. */
    prequalLinkId?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    /** @format date-time */
    dateOfBirth: string;
    ssn?: string | null;
    /**
     * Applicant email. Required by GreenSky's soft-pull submission; SFC does not use it.
     * Callers should populate whenever the funnel has collected it.
     */
    emailAddress?: string | null;
    /**
     * Applicant mobile phone (10 digits). Required by GreenSky's soft-pull submission;
     * SFC does not use it. Callers should populate whenever the funnel has collected it.
     */
    primaryPhone?: string | null;
    /**
     * Fraud/fingerprint blackbox (Iovation) captured client-side by the MFE. Required by
     * GreenSky for soft-pull; SFC ignores it. Optional.
     */
    iovationBlackbox?: string | null;
    /** Technician last name; GreenSky matches it for compliance-training enforcement. SFC ignores it. */
    technicianLastName?: string | null;
    /** Technician phone for GreenSky's compliance check. SFC ignores it. */
    technicianPhone?: string | null;
    /** Technician email for GreenSky's compliance check. SFC ignores it. */
    technicianEmail?: string | null;
    address?: Address | null;
    /** @format decimal */
    grossMonthlyIncome?: number | null;
    /** @format decimal */
    requestedAmount: number;
    planNumbers?: string[] | null;
    /**
     * Personal details of the co-applicant when joint credit is requested.
     * Leave empty/omit when there is no co-applicant. Supported by GreenSky and
     * ServiceFinance soft-pull when the funnel collects co-applicant data.
     */
    coApplicant?: LoanApplicant | null;
}

export interface LoansQueryResult {
    /** The loans returned from the query */
    loans?: LoanApplicationRead[] | null;
    /**
     * Total number of loans matching the query
     * @format int32
     */
    count: number;
}

export interface LocCreated {
    jobId?: string | null;
    invoiceId?: string | null;
    tenantId?: string | null;
    blobStoragePath?: string | null;
}

export interface RecalculateOfferData {
    planNumber?: string | null;
    /** @format decimal */
    loanAmount: number;
}

export interface PutLoanApplicationResult {
    loanId?: string | null;
}

export type ImportLoanApplicationRequest = LoanApplicationRead & object;

export interface AuthorizeLoanRequestDto {
    improvementInfos?: ImprovementInfo[] | null;
    /** @format decimal */
    amount: number;
    planNumber?: string | null;
}

export interface ImprovementInfo {
    name?: string | null;
    brand?: string | null;
    description?: string | null;
    /** Should be provided when product name is "Other" */
    otherName?: string | null;
    /** Should be provided when brand name is "Other" */
    otherBrand?: string | null;
}

/** DTO for the SendSalesSlip request. */
export interface SendSalesSlipRequestDto {
    email?: string | null;
    /** @format date */
    dateOfBirth: string;
    /** Optional. Target a specific authorization by ID. Defaults to the first authorization if not provided. */
    authorizationId?: string | null;
}

export interface KeyValuePairOfStringAndString {
    key?: string | null;
    value?: string | null;
}

export interface OrganizationUser {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    enabled: boolean;
}

/** Contains information about a kicked-off plans-synchronization operation/run. */
export interface PlansSynchronizationInfo {
    /** Gets or sets the tenant identifier for which synchronization was started. */
    tenantId?: string | null;
    /** Gets or sets the list of external account identifiers (as known to Wells Fargo) for which synchronization was started. */
    externalIds?: string[] | null;
    /** Gets or sets the version used to append results to the right availability record. */
    version?: string | null;
}

/**
 * Read-only eligibility result used by the MFE on page load to decide whether to render the
 * financing card and what amount to prefill. When Eligible is false the MFE
 * should simply not render the card without blocking the rest of the page.
 */
export interface ProviderFinancingEligibilityResponse {
    /** True when the tenant has the requested provider enabled and configured with a usable estimate range. */
    eligible: boolean;
    /**
     * The default financing amount to prefill in the form. Populated only when Eligible is true;
     * otherwise 0.
     * @format decimal
     */
    defaultFinancingAmount: number;
}

export interface StatusResponse {
    /**
     * The current server time in UTC
     * @format date-time
     */
    timestamp: string;
    isUp: boolean;
    /** Top level assembly version */
    assemblyVersion?: string | null;
    /** Application Assembly Name */
    application?: string | null;
}

export interface TelemetryResponse {
    totalLoansPerLastNDays?: Record<string, number>;
    activeTenantsPerLastNDays?: Record<string, number>;
    /** @format int32 */
    totalTenantsSet: number;
}

export type TenantSettingsWrite = TenantSettings & object;

export interface TenantSettings {
    trainingMode: boolean;
    presentationType: PresentationType;
    allowedOnlineEstimatesProviders?: string[] | null;
    allowedOnlineEstimatesSecondLookProviders?: string[] | null;
    /** @format decimal */
    secondLookMinRequestedAmount?: number | null;
    /** This flag is used, along with the plan optimizer feature flag, to hide ineligible plans */
    hideIneligiblePlans: boolean;
    showEstimatedFinancing?: boolean | null;
    showGreenSkyRemainingSpend?: boolean | null;
    /**
     * When true, the online-estimates/homeowner flow may run second look using the configured provider.
     * When false/null, the online-estimates flow does not run second look. Does not affect the technician flow.
     */
    onlineEstimatesSecondLookEnabled?: boolean | null;
}

export enum PresentationType {
    NotSet = 'notSet',
    LeadWithMonthlyPrice = 'leadWithMonthlyPrice',
    LeadWithTotalPrice = 'leadWithTotalPrice',
    OnlyDisplayMonthlyPrice = 'onlyDisplayMonthlyPrice',
    OnlyDisplayTotalPrice = 'onlyDisplayTotalPrice',
}

export type TenantSettingsRead = TenantSettings & {
    tenantId?: string | null;
    /** @format date-time */
    updatedAt?: string;
    updatedByUserId?: string | null;
};

export type ProviderPreferenceWrite = ProviderPreferenceBase & object;

export interface ProviderPreferenceBase {
    enabled: boolean;
    preferred: boolean;
    disabledBUs?: string[] | null;
}

export interface UpdatePreferredProviderRequest {
    providerName?: string | null;
}

export type ProviderPreferenceRead = ProviderPreferenceBase & {
    tenantId?: string | null;
    providerName?: string | null;
    /** @format date-time */
    updatedAt?: string;
    /** @format date-time */
    enabledAt?: string | null;
    updatedByUserId?: string | null;
    isSecondaryCalculationProvider?: boolean;
};

export interface TrainingStatusResponse {
    isValid: boolean;
    trainingMessage?: string | null;
    expirationDate?: string | null;
    trainingAvailable: boolean;
    trainingUrl?: string | null;
    showTrainingAlert: boolean;
}

export interface FinancingOfferedSlim {
    tenantId?: string | null;
    jobId?: string | null;
    businessUnitId?: string | null;
}

export interface CreateFinancingOfferedRequest {
    clickSource?: string | null;
    tenantId?: string | null;
    jobId?: string | null;
    businessUnitId?: string | null;
    technicianId?: string | null;
    /** @format date-time */
    createdOn: string;
}

export type MetricsExportMetricsAsInSampleData = any;

export type MetricsExportMetricsAsInDocsData = any;

export type LoansSubmitApplicationData = SubmitLoanApiResponse;

export type LoansSubmitApplicationError = ErrorInfo[] | ProblemDetails;

export type LoansSubmitApplication2Data = SubmitLoanApiResponse;

export type LoansSubmitApplication2Error = ErrorInfo[] | ProblemDetails;

export type LoansGetApplicationData = GetLoanApiResponse;

export type LoansGetApplicationError = ErrorInfo[] | ProblemDetails;

export type LoansGetApplication2Data = GetLoanApiResponse;

export type LoansGetApplication2Error = ErrorInfo[] | ProblemDetails;

export type LoansGetUpdatedApplicationData = GetLoanApiResponse;

export type LoansGetUpdatedApplicationError = ErrorInfo[] | ProblemDetails;

export type LoansGetUpdatedApplication2Data = GetLoanApiResponse;

export type LoansGetUpdatedApplication2Error = ErrorInfo[] | ProblemDetails;

export type LoansCreateApplicationLinkData = CreateApplicationLinkApiResponse;

export type LoansCreateApplicationLinkError = ErrorInfo[] | ProblemDetails;

export type LoansCreateApplicationLink2Data = CreateApplicationLinkApiResponse;

export type LoansCreateApplicationLink2Error = ErrorInfo[] | ProblemDetails;

export type LoansGenerateDealerAuthorizationDocumentData = LoanDocument;

export type LoansGenerateDealerAuthorizationDocumentError = ErrorInfo[];

export type LoansGenerateDealerAuthorizationDocument2Data = LoanDocument;

export type LoansGenerateDealerAuthorizationDocument2Error = ErrorInfo[];

export type LoansGetDealerDocumentFileData = any;

export type LoansGetDealerDocumentFile2Data = any;

export type LoansSignDealerAuthorizationDocumentData = any;

export type LoansSignDealerAuthorizationDocumentError = ErrorInfo[];

export type LoansSignDealerAuthorizationDocument2Data = any;

export type LoansSignDealerAuthorizationDocument2Error = ErrorInfo[];

export type LoansUpdateCustomerAvailableCreditData = CustomerAvailableCreditResponse;

export type LoansUpdateCustomerAvailableCreditError = ErrorInfo[];

export type LoansUpdateCustomerAvailableCredit2Data = CustomerAvailableCreditResponse;

export type LoansUpdateCustomerAvailableCredit2Error = ErrorInfo[];

export type OffersGetOffersData = GetOffersApiResponseCompatible;

export type OffersGetOffersError = ProblemDetails;

export type OffersApplyForOfferData = ApplyForOfferApiResponse;

export type OffersApplyForOfferError = ErrorInfo[] | ProblemDetails;

export type OffersGetOffers2Data = GetOffersApiResponseCompatible;

export type OffersGetOffers2Error = ProblemDetails;

export type OffersApplyForOffer2Data = ApplyForOfferApiResponse;

export type OffersApplyForOffer2Error = ErrorInfo[] | ProblemDetails;

export interface ProvidersGetCatalogParams {
    /** Optional. Business unit id required by some providers (e.g. Finturf) to resolve the merchant for the catalog. */
    businessUnitId?: string | null;
    provider: Provider;
    /** Type of the catalog to load. */
    catalogName: string;
}

export type ProvidersGetCatalogData = GetCatalogApiResponse;

export type ProvidersGetCatalogError = ErrorInfo[] | ProblemDetails;

export interface ProvidersGetCatalog2Params {
    /** Optional. Business unit id required by some providers (e.g. Finturf) to resolve the merchant for the catalog. */
    businessUnitId?: string | null;
    provider: Provider;
    /** Type of the catalog to load. */
    catalogName: string;
}

export type ProvidersGetCatalog2Data = GetCatalogApiResponse;

export type ProvidersGetCatalog2Error = ErrorInfo[] | ProblemDetails;

export interface ImprovementsGetProviderImprovementsParams {
    tenantId: string | null;
    providerName: string;
}

export type ImprovementsGetProviderImprovementsData = ImprovementType[];

export interface ImprovementsGetProviderImprovements2Params {
    tenantId: string | null;
    providerName: string;
}

export type ImprovementsGetProviderImprovements2Data = ImprovementType[];

export interface LegalDisclosuresGetLegalDisclosuresParams {
    /** The TenantId. */
    tenantId: string | null;
    /** Optional; type of disclosure, such as "solar". */
    type?: string | null;
    /**
     * Optional; provide this parameter if this business unit has a separate financing account.
     *
     */
    buId?: string | null;
    /** Name of the financing provider. */
    providerName: string;
}

export type LegalDisclosuresGetLegalDisclosuresData = DisclosuresResponse;

export type LegalDisclosuresGetLegalDisclosuresError = ErrorInfo[];

export interface LegalDisclosuresGetLegalDisclosures2Params {
    /** The TenantId. */
    tenantId: string | null;
    /** Optional; type of disclosure, such as "solar". */
    type?: string | null;
    /**
     * Optional; provide this parameter if this business unit has a separate financing account.
     *
     */
    buId?: string | null;
    /** Name of the financing provider. */
    providerName: string;
}

export type LegalDisclosuresGetLegalDisclosures2Data = DisclosuresResponse;

export type LegalDisclosuresGetLegalDisclosures2Error = ErrorInfo[];

export type LoansGenerateLoanDocumentsData = LoanDocument;

export type LoansGenerateLoanDocumentsError = ErrorInfo[];

export type LoansGenerateLoanDocuments2Data = LoanDocument;

export type LoansGenerateLoanDocuments2Error = ErrorInfo[];

export type LoansSubmitExternalApplicationData = ExternalApplicationResponse;

export type LoansSubmitExternalApplicationError = ErrorInfo[];

export type LoansSubmitExternalApplication2Data = ExternalApplicationResponse;

export type LoansSubmitExternalApplication2Error = ErrorInfo[];

export type LoansChangeOrderData = LoanApplicationRead;

export type LoansChangeOrderError = ErrorInfo[];

export type LoansChangeOrder2Data = LoanApplicationRead;

export type LoansChangeOrder2Error = ErrorInfo[];

export type LoansUpdateLoanApplicationPayload = Operation[];

export interface LoansUpdateLoanApplicationParams {
    /** @default false */
    isError: boolean;
    id: string;
}

export type LoansUpdateLoanApplicationData = any;

export type LoansUpdateLoanApplicationError = ErrorInfo[];

export type LoansUpdateLoanApplication2Payload = Operation[];

export interface LoansUpdateLoanApplication2Params {
    /** @default false */
    isError: boolean;
    id: string;
}

export type LoansUpdateLoanApplication2Data = any;

export type LoansUpdateLoanApplication2Error = ErrorInfo[];

export type LoansUpdateLoanApplicationAuthorizedPayload = Operation[];

export interface LoansUpdateLoanApplicationAuthorizedParams {
    /** @default false */
    isError: boolean;
    id: string;
}

export type LoansUpdateLoanApplicationAuthorizedData = any;

export type LoansUpdateLoanApplicationAuthorizedError = ErrorInfo[];

export type LoansPublishLoanApplicationsData = any;

export type LoansPublishLoanApplicationsError = ErrorInfo[];

export type LoansPublishLoanApplications2Data = any;

export type LoansPublishLoanApplications2Error = ErrorInfo[];

export type LoansUpdateAuthorizationStatusData = LoanAuthorization;

export type LoansUpdateAuthorizationStatus2Data = LoanAuthorization;

export type LoansUpdateAuthorizationStatusByAuthorizationIdData = LoanAuthorization;

export type LoansUpdateAuthorizationStatusByAuthorizationId2Data = LoanAuthorization;

export type LoansSearchAndImportData = LoanApplicationRead;

export type LoansSearchAndImportError = ErrorInfo[];

export type LoansSearchAndImport2Data = LoanApplicationRead;

export type LoansSearchAndImport2Error = ErrorInfo[];

export type LoansUpdateProjectsData = any;

export type LoansUpdateProjectsError = ErrorInfo[];

export type LoansUpdateProjects2Data = any;

export type LoansUpdateProjects2Error = ErrorInfo[];

export interface LoansGetProjectTypesParams {
    /** Optional list of specific project types to filter by */
    types?: string[] | null;
    /** The loan identifier */
    id: string;
}

export type LoansGetProjectTypesData = ProjectType[];

export type LoansGetProjectTypesError = ErrorInfo[];

export interface LoansGetProjectTypes2Params {
    /** Optional list of specific project types to filter by */
    types?: string[] | null;
    /** The loan identifier */
    id: string;
}

export type LoansGetProjectTypes2Data = ProjectType[];

export type LoansGetProjectTypes2Error = ErrorInfo[];

export interface AccountsGetParams {
    /** ID of the tenant for which to look up the financing account. */
    tenantId: string | null;
    /** Optional; ID of the business unit for which to look up the financing account. If not provided, the endpoint will return the information for all of the accounts, including the default account and account overrides for specific business units. */
    buId?: string | null;
    generalProviderName?: string | null;
    /** Financing provider for which to look up the account. */
    providerName: string;
}

export type AccountsGetData = TenantAccountRead;

export type AccountsGetError = ErrorInfo[];

export interface AccountsPutParams {
    /** ID of the tenant for which to look up the financing account. */
    tenantId: string | null;
    /** Financing provider for which the account is being saved. */
    providerName: string;
}

export type AccountsPutData = any;

export type AccountsPutError = ErrorInfo[];

export interface AccountsGet2Params {
    /** ID of the tenant for which to look up the financing account. */
    tenantId: string | null;
    /** Optional; ID of the business unit for which to look up the financing account. If not provided, the endpoint will return the information for all of the accounts, including the default account and account overrides for specific business units. */
    buId?: string | null;
    generalProviderName?: string | null;
    /** Financing provider for which to look up the account. */
    providerName: string;
}

export type AccountsGet2Data = TenantAccountRead;

export type AccountsGet2Error = ErrorInfo[];

export interface AccountsPut2Params {
    /** ID of the tenant for which to look up the financing account. */
    tenantId: string | null;
    /** Financing provider for which the account is being saved. */
    providerName: string;
}

export type AccountsPut2Data = any;

export type AccountsPut2Error = ErrorInfo[];

export interface AccountsPutFinanceItParams {
    /** ID of the tenant for which to look up the financing account. */
    tenantId: string | null;
}

export type AccountsPutFinanceItData = any;

export type AccountsPutFinanceItError = ErrorInfo[];

export interface AccountsPutFinanceIt2Params {
    /** ID of the tenant for which to look up the financing account. */
    tenantId: string | null;
}

export type AccountsPutFinanceIt2Data = any;

export type AccountsPutFinanceIt2Error = ErrorInfo[];

export type AccountsPublishAccountsData = PublishAllAccountsResponse;

export type AccountsPublishAccountsError = ErrorInfo[];

export type AccountsPublishAccounts2Data = PublishAllAccountsResponse;

export type AccountsPublishAccounts2Error = ErrorInfo[];

export type CustomerAuthStartChallengeData = CustomerAuthChallengeStatus;

export type CustomerAuthStartChallengeError = ErrorInfo[];

export type CustomerAuthStartChallenge2Data = CustomerAuthChallengeStatus;

export type CustomerAuthStartChallenge2Error = ErrorInfo[];

export type CustomerAuthCompleteChallengeData = CustomerAuthChallengeStatus;

export type CustomerAuthCompleteChallengeError = ErrorInfo[];

export type CustomerAuthCompleteChallenge2Data = CustomerAuthChallengeStatus;

export type CustomerAuthCompleteChallenge2Error = ErrorInfo[];

export type CustomersFindOneCustomerData = FindOneCustomerResponse;

export type CustomersFindOneCustomerError = ErrorInfo[];

export interface CustomersGetCustomerDetailsParams {
    TenantId?: string | null;
    CustomerIds?: string[] | null;
}

export type CustomersGetCustomerDetailsData = GetCustomerDetailsResponse;

export type CustomersGetCustomerDetailsError = ErrorInfo[];

export type LinksCreateLinkData = CustomerFinancingLinkDto;

export type LinksCreateLinkError = ErrorInfo[] | ProblemDetails;

export interface LinksGetLinksParams {
    /** Optional collection of providers to filter links */
    Providers?: Provider[] | null;
    CustomerId?: string | null;
    JobId?: string | null;
    TenantId?: string | null;
    BuId?: string | null;
}

export type LinksGetLinksData = GetCustomerFinancingLinksResponse;

export type LinksGetLinksError = ErrorInfo[] | ProblemDetails;

export type LinksCreateLink2Data = CustomerFinancingLinkDto;

export type LinksCreateLink2Error = ErrorInfo[] | ProblemDetails;

export interface LinksGetLinks2Params {
    /** Optional collection of providers to filter links */
    Providers?: Provider[] | null;
    CustomerId?: string | null;
    JobId?: string | null;
    TenantId?: string | null;
    BuId?: string | null;
}

export type LinksGetLinks2Data = GetCustomerFinancingLinksResponse;

export type LinksGetLinks2Error = ErrorInfo[] | ProblemDetails;

export type LinksGetLinkByShortCodeData = CustomerFinancingLinkDto;

export type LinksGetLinkByShortCodeError = ErrorInfo[] | ProblemDetails;

export type LinksGetLinkByShortCode2Data = CustomerFinancingLinkDto;

export type LinksGetLinkByShortCode2Error = ErrorInfo[] | ProblemDetails;

export type LoansSubmitApplication22Data = SubmitApplicationResult;

export type LoansSubmitApplication22Error = ErrorInfo[];

export interface LoansGetLoansByQueryParams {
    /** The tenant id if omitted all tenants will be returned */
    tenantId?: string | null;
    /**
     * optional start time in UTC
     * @format date-time
     */
    from?: string | null;
    /**
     * optional end time in UTC
     * @format date-time
     */
    to?: string | null;
    /** optional status filter */
    status?: LoanStatus2 | null;
    /**
     * allows pagination functionality similar to the skip in linq/lambda skipping X results will not affect the count in the result
     * @format int32
     */
    skip?: number | null;
    /**
     * allows pagination functionality similar to the skip in linq/lambda how many loans to return will not affect the count in the result
     * @format int32
     */
    take?: number | null;
    /** optional provider name filter */
    providerName?: string | null;
    /** optional customerId filter */
    customerId?: string | null;
    technicianId?: string | null;
    statuses?: LoanStatus2[] | null;
    jobId?: string | null;
    /** optional business unit ID filter */
    buid?: string | null;
    prequalId?: string | null;
}

export type LoansGetLoansByQueryData = LoansQueryResult;

export type LoansGetLoansByQueryError = ErrorInfo[];

export type LoansSubmitApplication23Data = SubmitApplicationResult;

export type LoansSubmitApplication23Error = ErrorInfo[];

export interface LoansGetLoansByQuery2Params {
    /** The tenant id if omitted all tenants will be returned */
    tenantId?: string | null;
    /**
     * optional start time in UTC
     * @format date-time
     */
    from?: string | null;
    /**
     * optional end time in UTC
     * @format date-time
     */
    to?: string | null;
    /** optional status filter */
    status?: LoanStatus2 | null;
    /**
     * allows pagination functionality similar to the skip in linq/lambda skipping X results will not affect the count in the result
     * @format int32
     */
    skip?: number | null;
    /**
     * allows pagination functionality similar to the skip in linq/lambda how many loans to return will not affect the count in the result
     * @format int32
     */
    take?: number | null;
    /** optional provider name filter */
    providerName?: string | null;
    /** optional customerId filter */
    customerId?: string | null;
    technicianId?: string | null;
    statuses?: LoanStatus2[] | null;
    jobId?: string | null;
    /** optional business unit ID filter */
    buid?: string | null;
    prequalId?: string | null;
}

export type LoansGetLoansByQuery2Data = LoansQueryResult;

export type LoansGetLoansByQuery2Error = ErrorInfo[];

export type LoansSubmitPrequalData = SubmitPrequalResponse;

export type LoansSubmitPrequalError = ErrorInfo[];

export type LoansSubmitPrequal2Data = SubmitPrequalResponse;

export type LoansSubmitPrequal2Error = ErrorInfo[];

export type LoansGenerateLoanDocuments22Data = LoanDocument;

export type LoansGenerateLoanDocuments22Error = ErrorInfo[];

export type LoansGenerateLoanDocuments23Data = LoanDocument;

export type LoansGenerateLoanDocuments23Error = ErrorInfo[];

export type LoansDeleteLoanDocumentsData = any;

export type LoansDeleteLoanDocuments2Data = any;

export type LoansDeleteAllDocumentsData = any;

export type LoansDeleteAllDocuments2Data = any;

export type LoansUpdateStatusFromProviderData = LoanStatus2;

export type LoansUpdateStatusFromProviderError = ErrorInfo[];

export type LoansUpdateStatusFromProvider2Data = LoanStatus2;

export type LoansUpdateStatusFromProvider2Error = ErrorInfo[];

export type LoansSignLoanDocumentData = any;

export type LoansSignLoanDocumentError = ErrorInfo[];

export type LoansSignLoanDocument2Data = any;

export type LoansSignLoanDocument2Error = ErrorInfo[];

export type LoansGetDocumentFileData = any;

export type LoansGetDocumentFile2Data = any;

export type LoansGetLoanByIdOrExternalIdData = LoanApplicationRead;

export type LoansRecalculateOfferData = LoanApplicationRead;

export type LoansRecalculateOfferError = ErrorInfo[];

export type LoansGetLoanByIdOrExternalId2Data = LoanApplicationRead;

export type LoansRecalculateOffer2Data = LoanApplicationRead;

export type LoansRecalculateOffer2Error = ErrorInfo[];

export type LoansRefreshLoanFromProviderData = LoanApplicationRead;

export type LoansRefreshLoanFromProvider2Data = LoanApplicationRead;

export type LoansGetAvailableCreditForLoansData = string[];

export type LoansGetAvailableCreditForLoans2Data = string[];

export interface LoansGetLoansWithNoJobParams {
    /** The tenant ID */
    tenantId: string | null;
    /** The customer ID */
    customerId: string | null;
    /** The business unit ID (merchant ID will be validated against prequalification merchant ID) */
    buId: string | null;
    /** Optional provider name. If not specified, checks GoodLeap and Synchrony. */
    providerName?: string | null;
}

export type LoansGetLoansWithNoJobData = LoanApplicationRead[];

export type LoansGetLoansWithNoJobError = ErrorInfo[];

export interface LoansGetLoansWithNoJob2Params {
    /** The tenant ID */
    tenantId: string | null;
    /** The customer ID */
    customerId: string | null;
    /** The business unit ID (merchant ID will be validated against prequalification merchant ID) */
    buId: string | null;
    /** Optional provider name. If not specified, checks GoodLeap and Synchrony. */
    providerName?: string | null;
}

export type LoansGetLoansWithNoJob2Data = LoanApplicationRead[];

export type LoansGetLoansWithNoJob2Error = ErrorInfo[];

export type LoansSubmitExternalApplication22Data = ExternalApplicationResponse;

export type LoansSubmitExternalApplication22Error = ErrorInfo[];

export type LoansSubmitExternalApplication23Data = ExternalApplicationResponse;

export type LoansSubmitExternalApplication23Error = ErrorInfo[];

export interface LoansObtainExternalFundingAccessLinkParams {
    providerName?: string | null;
    loanId?: string | null;
    tenantId?: string | null;
    buId?: string | null;
    technicianEmail?: string | null;
}

export type LoansObtainExternalFundingAccessLinkData = ExternalApplicationResponse;

export type LoansObtainExternalFundingAccessLinkError = ErrorInfo[];

export interface LoansObtainExternalFundingAccessLink2Params {
    providerName?: string | null;
    loanId?: string | null;
    tenantId?: string | null;
    buId?: string | null;
    technicianEmail?: string | null;
}

export type LoansObtainExternalFundingAccessLink2Data = ExternalApplicationResponse;

export type LoansObtainExternalFundingAccessLink2Error = ErrorInfo[];

export type LoansProcessLocData = any;

export type LoansProcessLocError = ErrorInfo[];

export type LoansProcessLoc2Data = any;

export type LoansProcessLoc2Error = ErrorInfo[];

export type LoansCreateAccountData = LoanApplicationRead;

export type LoansCreateAccountError = ErrorInfo[];

export type LoansCreateAccount2Data = LoanApplicationRead;

export type LoansCreateAccount2Error = ErrorInfo[];

export type LoansActiveAccountData = LoanApplicationRead;

export type LoansActiveAccountError = ErrorInfo[];

export type LoansActiveAccount2Data = LoanApplicationRead;

export type LoansActiveAccount2Error = ErrorInfo[];

export type LoansPutLoanApplicationData = PutLoanApplicationResult;

export type LoansPutLoanApplicationError = ErrorInfo[];

export type LoansPutLoanApplication2Data = PutLoanApplicationResult;

export type LoansPutLoanApplication2Error = ErrorInfo[];

export interface LoansGetLoansRequiringUpdateParams {
    /**
     * Optional max number of records to return
     * @format int32
     */
    batchSize?: number | null;
    /**
     * Optional cutOff for UpdatedAt. Returns loans updated before this date.
     * @format date-time
     */
    includeBeforeDate?: string | null;
    /** Optional loan statuses filter */
    status?: LoanStatus2[] | null;
    /**
     * Deprecated. Use includeBeforeDate instead.
     * @format date-time
     */
    lastUpdatedCutoff?: string | null;
    /**
     * Optional cutOff for UpdatedAt. Returns loans updated after this date.
     * @format date-time
     */
    includeAfterDate?: string | null;
    /** Financing provider (e.g. GreenSky) */
    providerName: string;
}

export type LoansGetLoansRequiringUpdateData = LoansQueryResult;

export interface LoansGetLoansRequiringUpdate2Params {
    /**
     * Optional max number of records to return
     * @format int32
     */
    batchSize?: number | null;
    /**
     * Optional cutOff for UpdatedAt. Returns loans updated before this date.
     * @format date-time
     */
    includeBeforeDate?: string | null;
    /** Optional loan statuses filter */
    status?: LoanStatus2[] | null;
    /**
     * Deprecated. Use includeBeforeDate instead.
     * @format date-time
     */
    lastUpdatedCutoff?: string | null;
    /**
     * Optional cutOff for UpdatedAt. Returns loans updated after this date.
     * @format date-time
     */
    includeAfterDate?: string | null;
    /** Financing provider (e.g. GreenSky) */
    providerName: string;
}

export type LoansGetLoansRequiringUpdate2Data = LoansQueryResult;

export type LoansAuthorizeLoanData = any;

export type LoansAuthorizeLoanError = ErrorInfo[];

export type LoansAuthorizeLoan2Data = any;

export type LoansAuthorizeLoan2Error = ErrorInfo[];

export type LoansSendSalesSlipData = any;

export type LoansSendSalesSlipError = ErrorInfo[];

export type LoansSendSalesSlip2Data = any;

export type LoansSendSalesSlip2Error = ErrorInfo[];

export type LoansVoidAuthorizationData = any;

export type LoansVoidAuthorizationError = ErrorInfo[];

export type LoansVoidAuthorization2Data = any;

export type LoansVoidAuthorization2Error = ErrorInfo[];

export interface LoansUploadSingleFilePayload {
    TenantId?: string | null;
    BusinessUnitId?: string | null;
    ProviderName?: string | null;
    /** @format binary */
    File?: File | null;
    Metadata?: Record<string, string>;
    metadata?: string | null;
}

export type LoansUploadSingleFileData = any;

export interface LoansUploadSingleFile2Payload {
    TenantId?: string | null;
    BusinessUnitId?: string | null;
    ProviderName?: string | null;
    /** @format binary */
    File?: File | null;
    Metadata?: Record<string, string>;
    metadata?: string | null;
}

export type LoansUploadSingleFile2Data = any;

export type ProvidersGetProvidersData = string[];

export type ProvidersGetProviders2Data = string[];

export type ProvidersTouchProviderData = string;

export type ProvidersTouchProvider2Data = string;

export interface ProvidersGetProviderImprovementsParams {
    tenantId: string | null;
    providerName: string;
}

export type ProvidersGetProviderImprovementsData = string[];

export interface ProvidersGetProviderImprovements2Params {
    tenantId: string | null;
    providerName: string;
}

export type ProvidersGetProviderImprovements2Data = string[];

export interface ProvidersGetLegalDisclosuresParams {
    /** The type of disclosure, such as "poBoxDisclosure". */
    type?: string | null;
    /** Name of the financing provider. Only "GreenSky" currently supported in V1. */
    providerName: string;
}

export type ProvidersGetLegalDisclosuresData = KeyValuePairOfStringAndString[];

export interface ProvidersGetLegalDisclosures2Params {
    /** The type of disclosure, such as "poBoxDisclosure". */
    type?: string | null;
    /** Name of the financing provider. Only "GreenSky" currently supported in V1. */
    providerName: string;
}

export type ProvidersGetLegalDisclosures2Data = KeyValuePairOfStringAndString[];

export interface ProvidersGetOperatingStatesParams {
    tenantId?: string | null;
    buId?: string | null;
    providerName: string;
}

export type ProvidersGetOperatingStatesData = string[];

export interface ProvidersGetOperatingStates2Params {
    tenantId?: string | null;
    buId?: string | null;
    providerName: string;
}

export type ProvidersGetOperatingStates2Data = string[];

export interface ProvidersGetUsersParams {
    tenantId?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    providerName: string;
}

export type ProvidersGetUsersData = OrganizationUser[];

export interface ProvidersGetUsers2Params {
    tenantId?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    providerName: string;
}

export type ProvidersGetUsers2Data = OrganizationUser[];

export interface ProvidersResyncPlansParams {
    tenantId: string | null;
    providerName: string;
}

export type ProvidersResyncPlansData = PlansSynchronizationInfo;

export interface ProvidersResyncPlans2Params {
    tenantId: string | null;
    providerName: string;
}

export type ProvidersResyncPlans2Data = PlansSynchronizationInfo;

export type ProvidersGetLogoData = any;

export type ProvidersGetLogoError = ErrorInfo[];

export type ProvidersGetLogo2Data = any;

export type ProvidersGetLogo2Error = ErrorInfo[];

export interface ProvidersGetFinancingEligibilityParams {
    /** The TenantId (required). */
    tenantId: string | null;
    /** Name of the financing provider (required). */
    providerName: string | null;
}

export type ProvidersGetFinancingEligibilityData = ProviderFinancingEligibilityResponse;

export type ProvidersGetFinancingEligibilityError = ErrorInfo[];

export interface ProvidersGetFinancingEligibility2Params {
    /** The TenantId (required). */
    tenantId: string | null;
    /** Name of the financing provider (required). */
    providerName: string | null;
}

export type ProvidersGetFinancingEligibility2Data = ProviderFinancingEligibilityResponse;

export type ProvidersGetFinancingEligibility2Error = ErrorInfo[];

export type StatusGetData = StatusResponse;

export type StatusMetricsData = any;

export type TechnicianAuthOAuthTokenExistenceCheckData = any;

export type TechnicianAuthOAuthTokenExistenceCheck2Data = any;

export type TelemetryGetData = TelemetryResponse;

export type TenantsSaveTenantSettingsData = any;

export type TenantsSaveTenantSettingsError = ErrorInfo[];

export type TenantsGetSettingsData = TenantSettingsRead;

export type TenantsSaveTenantSettings2Data = any;

export type TenantsSaveTenantSettings2Error = ErrorInfo[];

export type TenantsGetSettings2Data = TenantSettingsRead;

export type TenantsSaveProviderPreferenceData = any;

export type TenantsSaveProviderPreferenceError = ErrorInfo[];

export type TenantsGetProviderPreferenceData = ProviderPreferenceRead;

export type TenantsSaveProviderPreference2Data = any;

export type TenantsSaveProviderPreference2Error = ErrorInfo[];

export type TenantsGetProviderPreference2Data = ProviderPreferenceRead;

export type TenantsUpdatePreferredProviderData = any;

export type TenantsUpdatePreferredProviderError = ErrorInfo[];

export type TenantsUpdatePreferredProvider2Data = any;

export type TenantsUpdatePreferredProvider2Error = ErrorInfo[];

export interface TenantsGetAllProviderPreferencesParams {
    businessUnitId?: string | null;
    tenantId: string;
}

export type TenantsGetAllProviderPreferencesData = ProviderPreferenceRead[];

export interface TenantsGetAllProviderPreferences2Params {
    businessUnitId?: string | null;
    tenantId: string;
}

export type TenantsGetAllProviderPreferences2Data = ProviderPreferenceRead[];

export interface TenantsGetTrainingStatusParams {
    businessUnitId?: string | null;
    technicianLastName?: string | null;
    technicianEmail?: string | null;
    technicianPhone?: string | null;
    technicianId?: string | null;
    merchantId?: string | null;
    tenantId: string;
}

export type TenantsGetTrainingStatusData = TrainingStatusResponse;

export interface TenantsGetTrainingStatus2Params {
    businessUnitId?: string | null;
    technicianLastName?: string | null;
    technicianEmail?: string | null;
    technicianPhone?: string | null;
    technicianId?: string | null;
    merchantId?: string | null;
    tenantId: string;
}

export type TenantsGetTrainingStatus2Data = TrainingStatusResponse;

export interface TenantsGetFinancingOfferedParams {
    /** optional job id */
    jobId?: string | null;
    /**
     * optional start time in UTC
     * @format date-time
     */
    from?: string | null;
    /**
     * optional end time in UTC
     * @format date-time
     */
    to?: string | null;
    /** The tenant id if omitted all tenants will be returned */
    tenantId: string;
}

export type TenantsGetFinancingOfferedData = FinancingOfferedSlim[];

export type TenantsStoreFinancingOfferedData = any;

export interface TenantsGetFinancingOffered2Params {
    /** optional job id */
    jobId?: string | null;
    /**
     * optional start time in UTC
     * @format date-time
     */
    from?: string | null;
    /**
     * optional end time in UTC
     * @format date-time
     */
    to?: string | null;
    /** The tenant id if omitted all tenants will be returned */
    tenantId: string;
}

export type TenantsGetFinancingOffered2Data = FinancingOfferedSlim[];

export type TenantsStoreFinancingOffered2Data = any;

import { inject, injectable, optional, symbolToken } from '@servicetitan/react-ioc';
import axios, { AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { RequestOrigin, type EntryPoint, type SourceMfe } from './request-attribution';
export { RequestOrigin } from './request-attribution';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<
    AxiosRequestConfig,
    'data' | 'params' | 'url' | 'responseType'
> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseType;
    /** request body */
    body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

@injectable()
export class HttpClient {
    sessionId: string;
    tenantId: string;
    tenantFriendlyName: string;
    actingUserId: string;
    requestOrigin: RequestOrigin;
    entryPoint?: EntryPoint;
    sourceMfe?: SourceMfe;
    financingProvider: string = 'Unspecified';

    constructor(
        sessionId: string,
        tenantId: string,
        tenantFriendlyName: string,
        actingUserId: string,
        requestOrigin: RequestOrigin,
        entryPoint?: EntryPoint,
        sourceMfe?: SourceMfe,
    ) {
        this.sessionId = sessionId;
        this.tenantId = tenantId;
        this.tenantFriendlyName = tenantFriendlyName;
        this.actingUserId = actingUserId;
        this.requestOrigin = requestOrigin;
        this.entryPoint = entryPoint;
        this.sourceMfe = sourceMfe;
    }

    public setFinancingProvider(provider: string) {
        this.financingProvider = provider;
    }

    protected stringifyFormItem(formItem: unknown) {
        if (typeof formItem === 'object' && formItem !== null) {
            return JSON.stringify(formItem);
        } else {
            return `${formItem}`;
        }
    }

    protected createFormData(input: Record<string, unknown>): FormData {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent: any[] = property instanceof Array ? property : [property];

            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }

            return formData;
        }, new FormData());
    }

    public request = async <T = any, _E = any>({
        secure,
        path,
        type,
        query,
        format,
        body,
        ...params
    }: FullRequestParams): Promise<AxiosResponse<T>> => {
        const responseFormat = format;

        if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
            body = this.createFormData(body as Record<string, unknown>);
        }

        if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
            body = JSON.stringify(body);
        }

        return axios.request({
            ...params,
            headers: {
                ...(params.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
                'X-ST-SessionId': this.sessionId,
                'X-ST-CorrelationId': uuidv4(),
                'X-ST-TenantId': this.tenantId,
                'X-ST-TenantFriendlyName': this.tenantFriendlyName,
                'X-ST-ActingUserId': this.actingUserId,
                'X-ST-FIN-Origin': this.requestOrigin,
                'X-ST-FIN-Provider': this.financingProvider,
                ...(this.entryPoint ? { 'X-ST-FIN-EntryPoint': this.entryPoint } : {}),
                ...(this.sourceMfe ? { 'X-ST-FIN-SourceMfe': this.sourceMfe } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
            paramsSerializer: { indexes: null },
        });
    };
}

export const SESSION_ID_FinancingApi = symbolToken<string>('SESSION_ID', false);
export const TENANT_ID_FinancingApi = symbolToken<string>('TENANT_ID', false);
export const TENANT_FRIENDLY_NAME_FinancingApi = symbolToken<string>('TENANT_FRIENDLY_NAME', false);
export const ACTING_USER_ID_FinancingApi = symbolToken<string>('ACTING_USER_ID', false);
export const REQUEST_ORIGIN_FinancingApi = symbolToken<string>('REQUEST_ORIGIN', false);
export const ENTRY_POINT_FinancingApi = symbolToken<string>('ENTRY_POINT', false);
export const SOURCE_MFE_FinancingApi = symbolToken<string>('SOURCE_MFE', false);

export const BASE_URL_TOKEN_FinancingApi = symbolToken<string>('BASE_URL_TOKEN', false);

/**
 * @title Financing Microservice
 * @version v1
 * @baseUrl http://localhost:5000
 */
@injectable()
export class FinancingApi extends HttpClient {
    constructor(
        @inject(SESSION_ID_FinancingApi) @optional() sessionId: string,
        @inject(TENANT_ID_FinancingApi) @optional() tenantId: string,
        @inject(TENANT_FRIENDLY_NAME_FinancingApi) @optional() tenantFriendlyName: string,
        @inject(ACTING_USER_ID_FinancingApi) @optional() actingUserId: string,
        @inject(REQUEST_ORIGIN_FinancingApi) @optional() requestOrigin: RequestOrigin,
        @inject(ENTRY_POINT_FinancingApi) @optional() entryPoint: EntryPoint,
        @inject(SOURCE_MFE_FinancingApi) @optional() sourceMfe: SourceMfe,
        @inject(BASE_URL_TOKEN_FinancingApi) @optional() private readonly baseUrl = '',
    ) {
        super(sessionId, tenantId, tenantFriendlyName, actingUserId, requestOrigin, entryPoint, sourceMfe);
    }

    public setFinancingProvider(provider: string): void {
        super.setFinancingProvider(provider);
    }

    /**
     * No description
     *
     * @tags Metrics
     * @name MetricsExportMetricsAsInSample
     * @request GET:/metrics/-exported
     * @secure
     */
    metricsExportMetricsAsInSample = (params: RequestParams = {}) =>
        this.request<MetricsExportMetricsAsInSampleData, any>({
            path: `/metrics/-exported`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Metrics
     * @name MetricsExportMetricsAsInDocs
     * @request GET:/metrics
     * @secure
     */
    metricsExportMetricsAsInDocs = (params: RequestParams = {}) =>
        this.request<MetricsExportMetricsAsInDocsData, any>({
            path: `/metrics`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSubmitApplication
     * @summary Submit a loan application.
     * @request POST:/v3/loans
     * @secure
     */
    loansSubmitApplication = (data: SubmitLoanApiRequest, params: RequestParams = {}) =>
        this.request<LoansSubmitApplicationData, LoansSubmitApplicationError>({
            path: `/v3/loans`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansGetApplication
     * @summary Get a loan application by ID.
     * @request GET:/v3/loans/{financingId}
     * @secure
     */
    loansGetApplication = (financingId: string, params: RequestParams = {}) =>
        this.request<LoansGetApplicationData, LoansGetApplicationError>({
            path: `/v3/loans/${financingId}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansGetUpdatedApplication
     * @summary Refresh the loan application details from the financing provider.
     * @request POST:/v3/loans/{financingId}/status
     * @secure
     */
    loansGetUpdatedApplication = (financingId: string, params: RequestParams = {}) =>
        this.request<LoansGetUpdatedApplicationData, LoansGetUpdatedApplicationError>({
            path: `/v3/loans/${financingId}/status`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansCreateApplicationLink
     * @summary Submit a loan application.
     * @request POST:/v3/loans/external
     * @secure
     */
    loansCreateApplicationLink = (
        data: CreateApplicationLinkApiRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansCreateApplicationLinkData, LoansCreateApplicationLinkError>({
            path: `/v3/loans/external`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description Requests the financing provider to generate Dealer Authorization Document for the loan application and makes them available for download.
     *
     * @tags Loans
     * @name LoansGenerateDealerAuthorizationDocument
     * @summary Generate loan documents
     * @request POST:/v3/loans/{loanId}/dealer-document
     * @secure
     */
    loansGenerateDealerAuthorizationDocument = (
        loanId: string,
        data: LoanDocumentRequest,
        params: RequestParams = {},
    ) =>
        this.request<
            LoansGenerateDealerAuthorizationDocumentData,
            LoansGenerateDealerAuthorizationDocumentError
        >({
            path: `/v3/loans/${loanId}/dealer-document`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This should usually be called after generating the dealer authorization document using POST /v3/loans/{loanId}/dealer-document.
     *
     * @tags Loans
     * @name LoansGetDealerDocumentFile
     * @summary Get the dealer authorization document file for the specific loan.
     * @request GET:/v3/loans/{loanId}/dealer-document-file
     * @secure
     */
    loansGetDealerDocumentFile = (loanId: string, params: RequestParams = {}) =>
        this.request<LoansGetDealerDocumentFileData, void>({
            path: `/v3/loans/${loanId}/dealer-document-file`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSignDealerAuthorizationDocument
     * @summary Submit Dealer Authorization Document Signature for a loan.
     * @request POST:/v3/loans/{loanId}/dealer-document-signature
     * @secure
     */
    loansSignDealerAuthorizationDocument = (
        loanId: string,
        data: SignLoanDocumentRequest,
        params: RequestParams = {},
    ) =>
        this.request<
            LoansSignDealerAuthorizationDocumentData,
            LoansSignDealerAuthorizationDocumentError
        >({
            path: `/v3/loans/${loanId}/dealer-document-signature`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateCustomerAvailableCredit
     * @summary Update customer's available credit from loan applications.
     * @request PUT:/v3/loans/tenants/{tenantId}/customers/{customerId}/available-credit
     * @secure
     */
    loansUpdateCustomerAvailableCredit = (
        tenantId: string,
        customerId: string,
        params: RequestParams = {},
    ) =>
        this.request<
            LoansUpdateCustomerAvailableCreditData,
            LoansUpdateCustomerAvailableCreditError
        >({
            path: `/v3/loans/tenants/${tenantId}/customers/${customerId}/available-credit`,
            method: 'PUT',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Offers
     * @name OffersGetOffers
     * @summary List the available loan offers for a submitted loan application.
     * @request GET:/v3/loans/{loanId}/offers
     * @secure
     */
    offersGetOffers = (loanId: string, params: RequestParams = {}) =>
        this.request<OffersGetOffersData, OffersGetOffersError>({
            path: `/v3/loans/${loanId}/offers`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Offers
     * @name OffersApplyForOffer
     * @summary Apply for a loan offer.
     * @request PATCH:/v3/loans/{loanId}/offers
     * @secure
     */
    offersApplyForOffer = (
        loanId: string,
        data: ApplyForOfferApiRequest,
        params: RequestParams = {},
    ) =>
        this.request<OffersApplyForOfferData, OffersApplyForOfferError>({
            path: `/v3/loans/${loanId}/offers`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description Gets a provider's catalog of available items for a certain category. This can be things like improvement types, product types, etc.
     *
     * @tags Providers
     * @name ProvidersGetCatalog
     * @summary Get a provider catalog.
     * @request GET:/v3/providers/{provider}/catalogs/{catalogName}
     * @secure
     */
    providersGetCatalog = (
        { provider, catalogName, ...query }: ProvidersGetCatalogParams,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetCatalogData, ProvidersGetCatalogError>({
            path: `/v3/providers/${provider}/catalogs/${catalogName}`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSubmitApplication2
     * @summary Submit a loan application.
     * @request POST:/api/financing/v3/loans
     * @secure
     */
    loansSubmitApplication2 = (data: SubmitLoanApiRequest, params: RequestParams = {}) =>
        this.request<LoansSubmitApplication2Data, LoansSubmitApplication2Error>({
            path: `/api/financing/v3/loans`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansGetApplication2
     * @summary Get a loan application by ID.
     * @request GET:/api/financing/v3/loans/{financingId}
     * @secure
     */
    loansGetApplication2 = (financingId: string, params: RequestParams = {}) =>
        this.request<LoansGetApplication2Data, LoansGetApplication2Error>({
            path: `/api/financing/v3/loans/${financingId}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansGetUpdatedApplication2
     * @summary Refresh the loan application details from the financing provider.
     * @request POST:/api/financing/v3/loans/{financingId}/status
     * @secure
     */
    loansGetUpdatedApplication2 = (financingId: string, params: RequestParams = {}) =>
        this.request<LoansGetUpdatedApplication2Data, LoansGetUpdatedApplication2Error>({
            path: `/api/financing/v3/loans/${financingId}/status`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansCreateApplicationLink2
     * @summary Submit a loan application.
     * @request POST:/api/financing/v3/loans/external
     * @secure
     */
    loansCreateApplicationLink2 = (
        data: CreateApplicationLinkApiRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansCreateApplicationLink2Data, LoansCreateApplicationLink2Error>({
            path: `/api/financing/v3/loans/external`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description Requests the financing provider to generate Dealer Authorization Document for the loan application and makes them available for download.
     *
     * @tags Loans
     * @name LoansGenerateDealerAuthorizationDocument2
     * @summary Generate loan documents
     * @request POST:/api/financing/v3/loans/{loanId}/dealer-document
     * @secure
     */
    loansGenerateDealerAuthorizationDocument2 = (
        loanId: string,
        data: LoanDocumentRequest,
        params: RequestParams = {},
    ) =>
        this.request<
            LoansGenerateDealerAuthorizationDocument2Data,
            LoansGenerateDealerAuthorizationDocument2Error
        >({
            path: `/api/financing/v3/loans/${loanId}/dealer-document`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This should usually be called after generating the dealer authorization document using POST /v3/loans/{loanId}/dealer-document.
     *
     * @tags Loans
     * @name LoansGetDealerDocumentFile2
     * @summary Get the dealer authorization document file for the specific loan.
     * @request GET:/api/financing/v3/loans/{loanId}/dealer-document-file
     * @secure
     */
    loansGetDealerDocumentFile2 = (loanId: string, params: RequestParams = {}) =>
        this.request<LoansGetDealerDocumentFile2Data, void>({
            path: `/api/financing/v3/loans/${loanId}/dealer-document-file`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSignDealerAuthorizationDocument2
     * @summary Submit Dealer Authorization Document Signature for a loan.
     * @request POST:/api/financing/v3/loans/{loanId}/dealer-document-signature
     * @secure
     */
    loansSignDealerAuthorizationDocument2 = (
        loanId: string,
        data: SignLoanDocumentRequest,
        params: RequestParams = {},
    ) =>
        this.request<
            LoansSignDealerAuthorizationDocument2Data,
            LoansSignDealerAuthorizationDocument2Error
        >({
            path: `/api/financing/v3/loans/${loanId}/dealer-document-signature`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateCustomerAvailableCredit2
     * @summary Update customer's available credit from loan applications.
     * @request PUT:/api/financing/v3/loans/tenants/{tenantId}/customers/{customerId}/available-credit
     * @secure
     */
    loansUpdateCustomerAvailableCredit2 = (
        tenantId: string,
        customerId: string,
        params: RequestParams = {},
    ) =>
        this.request<
            LoansUpdateCustomerAvailableCredit2Data,
            LoansUpdateCustomerAvailableCredit2Error
        >({
            path: `/api/financing/v3/loans/tenants/${tenantId}/customers/${customerId}/available-credit`,
            method: 'PUT',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Offers
     * @name OffersGetOffers2
     * @summary List the available loan offers for a submitted loan application.
     * @request GET:/api/financing/v3/loans/{loanId}/offers
     * @secure
     */
    offersGetOffers2 = (loanId: string, params: RequestParams = {}) =>
        this.request<OffersGetOffers2Data, OffersGetOffers2Error>({
            path: `/api/financing/v3/loans/${loanId}/offers`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Offers
     * @name OffersApplyForOffer2
     * @summary Apply for a loan offer.
     * @request PATCH:/api/financing/v3/loans/{loanId}/offers
     * @secure
     */
    offersApplyForOffer2 = (
        loanId: string,
        data: ApplyForOfferApiRequest,
        params: RequestParams = {},
    ) =>
        this.request<OffersApplyForOffer2Data, OffersApplyForOffer2Error>({
            path: `/api/financing/v3/loans/${loanId}/offers`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description Gets a provider's catalog of available items for a certain category. This can be things like improvement types, product types, etc.
     *
     * @tags Providers
     * @name ProvidersGetCatalog2
     * @summary Get a provider catalog.
     * @request GET:/api/financing/v3/providers/{provider}/catalogs/{catalogName}
     * @secure
     */
    providersGetCatalog2 = (
        { provider, catalogName, ...query }: ProvidersGetCatalog2Params,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetCatalog2Data, ProvidersGetCatalog2Error>({
            path: `/api/financing/v3/providers/${provider}/catalogs/${catalogName}`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ImprovementsGetProviderImprovements2
     * @summary Returns the list of improvements supported by the financing provider.
     * @request GET:/api/financing/v2/providers/{providerName}/improvements
     * @secure
     */
    improvementsGetProviderImprovements2 = (
        { providerName, ...query }: ImprovementsGetProviderImprovements2Params,
        params: RequestParams = {},
    ) =>
        this.request<ImprovementsGetProviderImprovements2Data, void>({
            path: `/api/financing/v2/providers/${providerName}/improvements`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name LegalDisclosuresGetLegalDisclosures2
     * @summary Gets legal disclosures.
     * @request GET:/api/financing/v2/providers/{providerName}/disclosures
     * @secure
     */
    legalDisclosuresGetLegalDisclosures2 = (
        { providerName, ...query }: LegalDisclosuresGetLegalDisclosures2Params,
        params: RequestParams = {},
    ) =>
        this.request<
            LegalDisclosuresGetLegalDisclosures2Data,
            LegalDisclosuresGetLegalDisclosures2Error
        >({
            path: `/api/financing/v2/providers/${providerName}/disclosures`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Requests the financing provider to generate documents for the loan application and makes them available for download.
     *
     * @tags Loans
     * @name LoansGenerateLoanDocuments2
     * @summary Generate loan documents
     * @request POST:/api/financing/v2/loans/{id}/document
     * @secure
     */
    loansGenerateLoanDocuments2 = (
        id: string,
        data: LoanDocumentRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansGenerateLoanDocuments2Data, LoansGenerateLoanDocuments2Error>({
            path: `/api/financing/v2/loans/${id}/document`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description Request the financing provider to either generate a link where the user can go to fill out the loan application or to send the user an email/SMS with a link to fill out the loan application.
     *
     * @tags Loans
     * @name LoansSubmitExternalApplication2
     * @summary Get a link or email for an external loan application.
     * @request POST:/api/financing/v2/loans/external
     * @secure
     */
    loansSubmitExternalApplication2 = (
        data: ExternalApplicationRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansSubmitExternalApplication2Data, LoansSubmitExternalApplication2Error>({
            path: `/api/financing/v2/loans/external`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description Submit a request to change an existing approved loan application. This may change the loan's status and will trigger new loan documents to be created.
     *
     * @tags Loans
     * @name LoansChangeOrder2
     * @summary Request to change loan application terms.
     * @request POST:/api/financing/v2/loans/external/{id}/changeorder
     * @secure
     */
    loansChangeOrder2 = (
        id: string,
        data: ChangeExternalOrderRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansChangeOrder2Data, LoansChangeOrder2Error>({
            path: `/api/financing/v2/loans/external/${id}/changeorder`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateLoanApplication2
     * @summary Updates an existing loan application record.
     * @request PATCH:/api/financing/v2/loans/{id}
     * @secure
     */
    loansUpdateLoanApplication2 = (
        { id, ...query }: LoansUpdateLoanApplication2Params,
        data: LoansUpdateLoanApplication2Payload,
        params: RequestParams = {},
    ) =>
        this.request<LoansUpdateLoanApplication2Data, LoansUpdateLoanApplication2Error>({
            path: `/api/financing/v2/loans/${id}`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description Specify loanIds to publish specific loans, tenantIds to publish all loans for given tenants, or startDate/endDate to publish loans within a date range (optionally combined with tenantIds to filter by tenant). If loanIds are specified, all other filters are ignored.
     *
     * @tags Loans
     * @name LoansPublishLoanApplications2
     * @summary Publishes (or re-publishes) existing loan application records
     * @request POST:/api/financing/v2/loans/publish
     * @secure
     */
    loansPublishLoanApplications2 = (
        data: PublishLoanApplicationsRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansPublishLoanApplications2Data, LoansPublishLoanApplications2Error>({
            path: `/api/financing/v2/loans/publish`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateAuthorizationStatus2
     * @summary Check/update authorization status for a specific loan, defaults to the first authorization.
     * @request POST:/api/financing/v2/loans/{loanId}/authorization-status
     * @secure
     */
    loansUpdateAuthorizationStatus2 = (loanId: string, params: RequestParams = {}) =>
        this.request<LoansUpdateAuthorizationStatus2Data, void>({
            path: `/api/financing/v2/loans/${loanId}/authorization-status`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateAuthorizationStatusByAuthorizationId2
     * @summary Check/update authorization status for a specific authorization by ID.
     * @request POST:/api/financing/v2/loans/{loanId}/authorization-status/{authorizationId}
     * @secure
     */
    loansUpdateAuthorizationStatusByAuthorizationId2 = (
        loanId: string,
        authorizationId: string,
        params: RequestParams = {},
    ) =>
        this.request<LoansUpdateAuthorizationStatusByAuthorizationId2Data, void>({
            path: `/api/financing/v2/loans/${loanId}/authorization-status/${authorizationId}`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSearchAndImport2
     * @summary Search and import a loan.
     * @request POST:/api/financing/v2/loans/imported
     * @secure
     */
    loansSearchAndImport2 = (data: ImportLoanSearchRequestDto, params: RequestParams = {}) =>
        this.request<LoansSearchAndImport2Data, LoansSearchAndImport2Error>({
            path: `/api/financing/v2/loans/imported`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateProjects2
     * @summary Updates projects for a Loan for GoodLeap.
     * @request PUT:/api/financing/v2/loans/{id}/projects
     * @secure
     */
    loansUpdateProjects2 = (id: string, data: PutProjectsRequest, params: RequestParams = {}) =>
        this.request<LoansUpdateProjects2Data, LoansUpdateProjects2Error>({
            path: `/api/financing/v2/loans/${id}/projects`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansGetProjectTypes2
     * @summary Retrieves project types for a loan application from GoodLeap.
     * @request GET:/api/financing/v2/loans/{id}/project-types
     * @secure
     */
    loansGetProjectTypes2 = (
        { id, ...query }: LoansGetProjectTypes2Params,
        params: RequestParams = {},
    ) =>
        this.request<LoansGetProjectTypes2Data, LoansGetProjectTypes2Error>({
            path: `/api/financing/v2/loans/${id}/project-types`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Returns the financing account settings for the specified tenant and provider. If buId is provided, returns only the account for that business unit; otherwise returns the default account and all per-BU overrides. The properties field in the response carries provider-specific settings — for example minEstimateAmount / maxEstimateAmount for Affirm.
     *
     * @tags Accounts
     * @name AccountsGet2
     * @summary Get financing account settings.
     * @request GET:/api/financing/v1/accounts/providers/{providerName}
     * @secure
     */
    accountsGet2 = ({ providerName, ...query }: AccountsGet2Params, params: RequestParams = {}) =>
        this.request<AccountsGet2Data, AccountsGet2Error>({
            path: `/api/financing/v1/accounts/providers/${providerName}`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Accounts
     * @name AccountsPut2
     * @summary Saves financing provider account settings for a tenant.
     * @request PUT:/api/financing/v1/accounts/providers/{providerName}
     * @secure
     */
    accountsPut2 = (
        { providerName, ...query }: AccountsPut2Params,
        data: TenantAccountWrite,
        params: RequestParams = {},
    ) =>
        this.request<AccountsPut2Data, AccountsPut2Error>({
            path: `/api/financing/v1/accounts/providers/${providerName}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Accounts
     * @name AccountsPutFinanceIt2
     * @summary Saves Financeit account for the provided tenant.
     * @request PUT:/api/financing/v1/accounts/providers/financeit
     * @secure
     */
    accountsPutFinanceIt2 = (
        query: AccountsPutFinanceIt2Params,
        data: FinanceItTenantAccountWrite,
        params: RequestParams = {},
    ) =>
        this.request<AccountsPutFinanceIt2Data, AccountsPutFinanceIt2Error>({
            path: `/api/financing/v1/accounts/providers/financeit`,
            method: 'PUT',
            baseURL: this.baseUrl,
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
 * No description
 *
 * @tags Accounts
 * @name AccountsPublishAccounts2
 * @summary Republishes every account for the given provider. Publishes a TenantAccountRead Kafka
event (consumed by financing-subscriber → provider adapters) and forwards each
non-General account directly to fin-plans so its account mirror stays in sync.
 * @request POST:/api/financing/v1/accounts/providers/{providerName}/exports
 * @secure
 */
    accountsPublishAccounts2 = (providerName: string, params: RequestParams = {}) =>
        this.request<AccountsPublishAccounts2Data, AccountsPublishAccounts2Error>({
            path: `/api/financing/v1/accounts/providers/${providerName}/exports`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description Attempts to start a new customer authentication challenge. Some providers (for now, just GreenSky) want to verify that a customer is who they say they are. This endpoint starts that process.
     *
     * @tags CustomerAuth
     * @name CustomerAuthStartChallenge2
     * @summary Start a customer authentication challenge.
     * @request POST:/api/financing/v1/customer-auth/providers/{providerName}/challenge
     * @secure
     */
    customerAuthStartChallenge2 = (
        providerName: string,
        data: AuthenticationChallengeStartRequest,
        params: RequestParams = {},
    ) =>
        this.request<CustomerAuthStartChallenge2Data, CustomerAuthStartChallenge2Error>({
            path: `/api/financing/v1/customer-auth/providers/${providerName}/challenge`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthCompleteChallenge2
     * @summary Attempts to complete a customer authentication challenge.
     * @request POST:/api/financing/v1/customer-auth/providers/{providerName}/challenge/{challengeId}/completed
     * @secure
     */
    customerAuthCompleteChallenge2 = (
        providerName: string,
        challengeId: string,
        data: AuthenticationChallengeCompleteRequest,
        params: RequestParams = {},
    ) =>
        this.request<CustomerAuthCompleteChallenge2Data, CustomerAuthCompleteChallenge2Error>({
            path: `/api/financing/v1/customer-auth/providers/${providerName}/challenge/${challengeId}/completed`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Links
     * @name LinksCreateLink2
     * @summary Request new link to Loan Application form in MFE for customer.
     * @request POST:/api/financing/v1/links
     * @secure
     */
    linksCreateLink2 = (data: CreateCustomerFinancingLinkApiRequest, params: RequestParams = {}) =>
        this.request<LinksCreateLink2Data, LinksCreateLink2Error>({
            path: `/api/financing/v1/links`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Links
     * @name LinksGetLinks2
     * @summary Get Links, generated for customer to apply for financing.
     * @request GET:/api/financing/v1/links
     * @secure
     */
    linksGetLinks2 = (query: LinksGetLinks2Params, params: RequestParams = {}) =>
        this.request<LinksGetLinks2Data, LinksGetLinks2Error>({
            path: `/api/financing/v1/links`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Links
     * @name LinksGetLinkByShortCode2
     * @summary Get a single link by short code
     * @request GET:/api/financing/v1/links/{shortCode}
     * @secure
     */
    linksGetLinkByShortCode2 = (shortCode: string, params: RequestParams = {}) =>
        this.request<LinksGetLinkByShortCode2Data, LinksGetLinkByShortCode2Error>({
            path: `/api/financing/v1/links/${shortCode}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSubmitApplication23
     * @summary Submit a loan application.
     * @request POST:/api/financing/v1/loans
     * @secure
     */
    loansSubmitApplication23 = (data: LoanApplication, params: RequestParams = {}) =>
        this.request<LoansSubmitApplication23Data, LoansSubmitApplication23Error>({
            path: `/api/financing/v1/loans`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansGetLoansByQuery2
     * @summary Return loans matching the filter criteria
     * @request GET:/api/financing/v1/loans
     * @secure
     */
    loansGetLoansByQuery2 = (query: LoansGetLoansByQuery2Params, params: RequestParams = {}) =>
        this.request<LoansGetLoansByQuery2Data, LoansGetLoansByQuery2Error>({
            path: `/api/financing/v1/loans`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
 * No description
 *
 * @tags Loans
 * @name LoansSubmitPrequal2
 * @summary Submit an inline soft-pull prequal (FIN-17539 REQ-LIFE-02). Creates a
LoanApplication row in prequalification-pending status, dispatches
to the resolved provider's soft-pull surface, and returns the outcome.
 * @request POST:/api/financing/v1/loans/prequal
 * @secure
 */
    loansSubmitPrequal2 = (data: SubmitPrequalRequest, params: RequestParams = {}) =>
        this.request<LoansSubmitPrequal2Data, LoansSubmitPrequal2Error>({
            path: `/api/financing/v1/loans/prequal`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description After the loan is approved, this endpoint can be used to generate the loan documents to be signed by the customer. Applicable to only Service Finance.
     *
     * @tags Loans
     * @name LoansGenerateLoanDocuments23
     * @summary Generate loan documents.
     * @request POST:/api/financing/v1/loans/{id}/document
     * @secure
     */
    loansGenerateLoanDocuments23 = (id: string, params: RequestParams = {}) =>
        this.request<LoansGenerateLoanDocuments23Data, LoansGenerateLoanDocuments23Error>({
            path: `/api/financing/v1/loans/${id}/document`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description This is used to clean up the documents after the loan application is completed or expired.
     *
     * @tags Loans
     * @name LoansDeleteLoanDocuments2
     * @summary Delete all documents for a loan.
     * @request DELETE:/api/financing/v1/loans/{LoanId}/document
     * @secure
     */
    loansDeleteLoanDocuments2 = (loanId: string, params: RequestParams = {}) =>
        this.request<LoansDeleteLoanDocuments2Data, void>({
            path: `/api/financing/v1/loans/${loanId}/document`,
            method: 'DELETE',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansDeleteAllDocuments2
     * @summary Delete loan documents for all loans.
     * @request DELETE:/api/financing/v1/loans/document/cleanup
     * @secure
     */
    loansDeleteAllDocuments2 = (params: RequestParams = {}) =>
        this.request<LoansDeleteAllDocuments2Data, void>({
            path: `/api/financing/v1/loans/document/cleanup`,
            method: 'DELETE',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateStatusFromProvider2
     * @summary Re-query the provider for the status of the loan application.
     * @request POST:/api/financing/v1/loans/{id}/status
     * @secure
     */
    loansUpdateStatusFromProvider2 = (id: string, params: RequestParams = {}) =>
        this.request<LoansUpdateStatusFromProvider2Data, LoansUpdateStatusFromProvider2Error>({
            path: `/api/financing/v1/loans/${id}/status`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSignLoanDocument2
     * @summary Submit a loan application signature.
     * @request POST:/api/financing/v1/loans/{id}/signInfo
     * @secure
     */
    loansSignLoanDocument2 = (
        id: string,
        data: SignLoanDocumentRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansSignLoanDocument2Data, LoansSignLoanDocument2Error>({
            path: `/api/financing/v1/loans/${id}/signInfo`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This should usually be called after creating the loan documents using POST /v1/loans/{id}/document.
     *
     * @tags Loans
     * @name LoansGetDocumentFile2
     * @summary Get the loan documents for the specific loan.
     * @request GET:/api/financing/v1/loans/{id}/documentfile
     * @secure
     */
    loansGetDocumentFile2 = (id: string, params: RequestParams = {}) =>
        this.request<LoansGetDocumentFile2Data, void>({
            path: `/api/financing/v1/loans/${id}/documentfile`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description ⚠️ DEPRECATED: This GET endpoint performs state-changing operations, which violates REST principles. Use PUT /v1/loans/{id}/refresh instead.
     *
     * @tags Loans
     * @name LoansGetLoanByIdOrExternalId2
     * @summary Re-query the provider for loan details.
     * @request GET:/api/financing/v1/loans/{id}
     * @deprecated
     * @secure
     */
    loansGetLoanByIdOrExternalId2 = (id: string, params: RequestParams = {}) =>
        this.request<LoansGetLoanByIdOrExternalId2Data, void>({
            path: `/api/financing/v1/loans/${id}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description This is a GreenSky-specific action that changes an existing loan application's plan and amount. After this action, the loan application status (approved/declined/counter-offer/etc) may change.
     *
     * @tags Loans
     * @name LoansRecalculateOffer2
     * @summary Recalculate offers for a loan.
     * @request PATCH:/api/financing/v1/loans/{id}
     * @secure
     */
    loansRecalculateOffer2 = (id: string, data: RecalculateOfferData, params: RequestParams = {}) =>
        this.request<LoansRecalculateOffer2Data, LoansRecalculateOffer2Error>({
            path: `/api/financing/v1/loans/${id}`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This endpoint queries the financing provider for the latest loan details and updates the local record if necessary. This may change the loan status, available credit, and other loan properties.
     *
     * @tags Loans
     * @name LoansRefreshLoanFromProvider2
     * @summary Refresh loan application details from the financing provider.
     * @request PUT:/api/financing/v1/loans/{id}/refresh
     * @secure
     */
    loansRefreshLoanFromProvider2 = (id: string, params: RequestParams = {}) =>
        this.request<LoansRefreshLoanFromProvider2Data, void>({
            path: `/api/financing/v1/loans/${id}/refresh`,
            method: 'PUT',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansGetAvailableCreditForLoans2
     * @summary Get the available credit for the customer.
     * @request GET:/api/financing/v1/loans/provider/{providerName}/tenant/{tenantId}/customer/{customerId}/availablecredit
     * @secure
     */
    loansGetAvailableCreditForLoans2 = (
        providerName: string,
        tenantId: string,
        customerId: string,
        params: RequestParams = {},
    ) =>
        this.request<LoansGetAvailableCreditForLoans2Data, void>({
            path: `/api/financing/v1/loans/provider/${providerName}/tenant/${tenantId}/customer/${customerId}/availablecredit`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description This endpoint returns loans that were created through the prequalification flow (without a job). It validates that the requesting business unit's merchant ID matches the prequalification business unit's merchant ID. If no provider name is specified, it checks both GoodLeap and Synchrony providers.
     *
     * @tags Loans
     * @name LoansGetLoansWithNoJob2
     * @summary Get loans for a customer that were created without a job ID.
     * @request GET:/api/financing/v1/loans/withNoJob
     * @secure
     */
    loansGetLoansWithNoJob2 = (query: LoansGetLoansWithNoJob2Params, params: RequestParams = {}) =>
        this.request<LoansGetLoansWithNoJob2Data, LoansGetLoansWithNoJob2Error>({
            path: `/api/financing/v1/loans/withNoJob`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Request the financing provider to either generate a link where the user can go to fill out the loan application or to send the user an email/SMS with a link to fill out the loan application.
     *
     * @tags Loans
     * @name LoansSubmitExternalApplication23
     * @summary Get a link or email for an external loan application.
     * @request POST:/api/financing/v1/loans/external
     * @secure
     */
    loansSubmitExternalApplication23 = (
        data: ExternalApplicationRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansSubmitExternalApplication23Data, LoansSubmitExternalApplication23Error>({
            path: `/api/financing/v1/loans/external`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansObtainExternalFundingAccessLink2
     * @summary Submit request to Financeit for obtaining the external funding status access link.
     * @request GET:/api/financing/v1/loans/externalfunding
     * @secure
     */
    loansObtainExternalFundingAccessLink2 = (
        query: LoansObtainExternalFundingAccessLink2Params,
        params: RequestParams = {},
    ) =>
        this.request<
            LoansObtainExternalFundingAccessLink2Data,
            LoansObtainExternalFundingAccessLink2Error
        >({
            path: `/api/financing/v1/loans/externalfunding`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description This endpoint is applicable only to Financeit. It submits a letter of completion that indicates that the job is complete and that the loan funds can now be released to the tenant.
     *
     * @tags Loans
     * @name LoansProcessLoc2
     * @summary Submit a letter of completion to the provider.
     * @request PUT:/api/financing/v1/loans/loc/tenants/{tenantId}/jobs/{jobId}
     * @secure
     */
    loansProcessLoc2 = (
        tenantId: string,
        jobId: string,
        data: LocCreated,
        params: RequestParams = {},
    ) =>
        this.request<LoansProcessLoc2Data, LoansProcessLoc2Error>({
            path: `/api/financing/v1/loans/loc/tenants/${tenantId}/jobs/${jobId}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This is a GreenSky-specific action that sets up a customer GreenSky account associated with the loan.
     *
     * @tags Loans
     * @name LoansCreateAccount2
     * @summary Create an account for the customer with the provider.
     * @request POST:/api/financing/v1/loans/{id}/account
     * @secure
     */
    loansCreateAccount2 = (id: string, params: RequestParams = {}) =>
        this.request<LoansCreateAccount2Data, LoansCreateAccount2Error>({
            path: `/api/financing/v1/loans/${id}/account`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description This is a GreenSky-specific action that activates the customer's GreenSky account.
     *
     * @tags Loans
     * @name LoansActiveAccount2
     * @summary Activate customer's account with the provider.
     * @request POST:/api/financing/v1/loans/{id}/activation
     * @secure
     */
    loansActiveAccount2 = (id: string, params: RequestParams = {}) =>
        this.request<LoansActiveAccount2Data, LoansActiveAccount2Error>({
            path: `/api/financing/v1/loans/${id}/activation`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansPutLoanApplication2
     * @summary Imports a loan application that was created in a different system.
     * @request PUT:/api/financing/v1/loans/{externalId}
     * @secure
     */
    loansPutLoanApplication2 = (
        externalId: string,
        data: ImportLoanApplicationRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansPutLoanApplication2Data, LoansPutLoanApplication2Error>({
            path: `/api/financing/v1/loans/${externalId}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description A loan may require update if it is in a non-terminal status (e.g. submitted) and has not been updated for a while.
     *
     * @tags Loans
     * @name LoansGetLoansRequiringUpdate2
     * @summary Finds loans that may require an update from the provider.
     * @request GET:/api/financing/v1/loans/provider/{providerName}/outdated
     * @secure
     */
    loansGetLoansRequiringUpdate2 = (
        { providerName, ...query }: LoansGetLoansRequiringUpdate2Params,
        params: RequestParams = {},
    ) =>
        this.request<LoansGetLoansRequiringUpdate2Data, any>({
            path: `/api/financing/v1/loans/provider/${providerName}/outdated`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description This endpoint supports GoodLeap and Synchrony.
     *
     * @tags Loans
     * @name LoansAuthorizeLoan2
     * @summary Authorize the sales slip.
     * @request POST:/api/financing/v1/loans/{id}/authorization
     * @secure
     */
    loansAuthorizeLoan2 = (id: string, data: AuthorizeLoanRequestDto, params: RequestParams = {}) =>
        this.request<LoansAuthorizeLoan2Data, LoansAuthorizeLoan2Error>({
            path: `/api/financing/v1/loans/${id}/authorization`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSendSalesSlip2
     * @summary Send the sales slip for a loan payment to the homeowner.
     * @request POST:/api/financing/v1/loans/{id}/salesSlip
     * @secure
     */
    loansSendSalesSlip2 = (id: string, data: SendSalesSlipRequestDto, params: RequestParams = {}) =>
        this.request<LoansSendSalesSlip2Data, LoansSendSalesSlip2Error>({
            path: `/api/financing/v1/loans/${id}/salesSlip`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This is a Synchrony-specific endpoint.
     *
     * @tags Loans
     * @name LoansVoidAuthorization2
     * @summary Void a sales slip authorization for a loan.
     * @request DELETE:/api/financing/v1/loans/{loanId}/authorizations/{authorizationId}
     * @secure
     */
    loansVoidAuthorization2 = (
        loanId: string,
        authorizationId: string,
        params: RequestParams = {},
    ) =>
        this.request<LoansVoidAuthorization2Data, LoansVoidAuthorization2Error>({
            path: `/api/financing/v1/loans/${loanId}/authorizations/${authorizationId}`,
            method: 'DELETE',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUploadSingleFile2
     * @request POST:/api/financing/v1/loans/{loanId}/files
     * @secure
     */
    loansUploadSingleFile2 = (
        loanId: string,
        data: LoansUploadSingleFile2Payload,
        params: RequestParams = {},
    ) =>
        this.request<LoansUploadSingleFile2Data, any>({
            path: `/api/financing/v1/loans/${loanId}/files`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.FormData,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersGetProviders2
     * @summary List all available financing providers.
     * @request GET:/api/financing/v1/providers
     * @secure
     */
    providersGetProviders2 = (params: RequestParams = {}) =>
        this.request<ProvidersGetProviders2Data, void>({
            path: `/api/financing/v1/providers`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersTouchProvider2
     * @summary Check whether the financing provider is supported by ServiceTitan.
     * @request HEAD:/api/financing/v1/providers/{providerName}
     * @secure
     */
    providersTouchProvider2 = (providerName: string, params: RequestParams = {}) =>
        this.request<ProvidersTouchProvider2Data, void>({
            path: `/api/financing/v1/providers/${providerName}`,
            method: 'HEAD',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersGetProviderImprovements2
     * @summary List all improvements supported by this financing provider.
     * @request GET:/api/financing/v1/providers/{providerName}/improvements
     * @secure
     */
    providersGetProviderImprovements2 = (
        { providerName, ...query }: ProvidersGetProviderImprovements2Params,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetProviderImprovements2Data, void>({
            path: `/api/financing/v1/providers/${providerName}/improvements`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersGetLegalDisclosures2
     * @summary Gets Legal Disclosures for the specified provider and disclosure type.
     * @request GET:/api/financing/v1/providers/{providerName}/disclosures
     * @secure
     */
    providersGetLegalDisclosures2 = (
        { providerName, ...query }: ProvidersGetLegalDisclosures2Params,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetLegalDisclosures2Data, void>({
            path: `/api/financing/v1/providers/${providerName}/disclosures`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Currently, this applies only to GoodLeap.
     *
     * @tags Providers
     * @name ProvidersGetOperatingStates2
     * @summary Get the list of US states in which the provider allows the tenant to offer loans
     * @request GET:/api/financing/v1/providers/{providerName}/states
     * @secure
     */
    providersGetOperatingStates2 = (
        { providerName, ...query }: ProvidersGetOperatingStates2Params,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetOperatingStates2Data, void>({
            path: `/api/financing/v1/providers/${providerName}/states`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Currently, this applies only to GoodLeap.
     *
     * @tags Providers
     * @name ProvidersGetUsers2
     * @summary List tenant's users (technicians) registered with the provider.
     * @request GET:/api/financing/v1/providers/{providerName}/users
     * @secure
     */
    providersGetUsers2 = (
        { providerName, ...query }: ProvidersGetUsers2Params,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetUsers2Data, void>({
            path: `/api/financing/v1/providers/${providerName}/users`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersResyncPlans2
     * @summary Force-resync cached plans from the provider.
     * @request POST:/api/financing/v1/providers/{providerName}/resync-plans
     * @secure
     */
    providersResyncPlans2 = (
        { providerName, ...query }: ProvidersResyncPlans2Params,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersResyncPlans2Data, void>({
            path: `/api/financing/v1/providers/${providerName}/resync-plans`,
            method: 'POST',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
 * No description
 *
 * @tags Providers
 * @name ProvidersGetLogo2
 * @summary Return a provider's logo. The file type may be different depending on the provider, so you would
need to check the response's content type to determine how to display it.
 * @request GET:/api/financing/v1/providers/{providerName}/logo
 * @secure
 */
    providersGetLogo2 = (providerName: string, params: RequestParams = {}) =>
        this.request<ProvidersGetLogo2Data, ProvidersGetLogo2Error>({
            path: `/api/financing/v1/providers/${providerName}/logo`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
 * No description
 *
 * @tags Providers
 * @name ProvidersGetFinancingEligibility2
 * @summary Read-only financing eligibility check, called by the MFE on page load to decide whether to render the
financing card and what amount to prefill. Creates no records and performs no writes.
 * @request GET:/api/financing/v1/providers/eligibility
 * @secure
 */
    providersGetFinancingEligibility2 = (
        query: ProvidersGetFinancingEligibility2Params,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetFinancingEligibility2Data, ProvidersGetFinancingEligibility2Error>(
            {
                path: `/api/financing/v1/providers/eligibility`,
                method: 'GET',
                baseURL: this.baseUrl,
                query: query,
                secure: true,
                ...params,
            },
        );

    /**
     * @description This endpoint completes the OAuth flow for a technician. Some providers (for now, only Financeit) require a technician to authenticate before they can view customer data. This endpoint is called by the provider's OAuth callback to complete the authentication process.
     *
     * @tags TechnicianAuth
     * @name TechnicianAuthOAuthTokenExistenceCheck2
     * @summary Complete technician authentication with a provider.
     * @request HEAD:/api/financing/v1/technician-auth/{providerName}/oauth/token
     * @secure
     */
    technicianAuthOAuthTokenExistenceCheck2 = (providerName: string, params: RequestParams = {}) =>
        this.request<TechnicianAuthOAuthTokenExistenceCheck2Data, void>({
            path: `/api/financing/v1/technician-auth/${providerName}/oauth/token`,
            method: 'HEAD',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsSaveTenantSettings2
     * @summary Updates tenant's general financing settings.
     * @request PUT:/api/financing/v1/tenants/{tenantId}/settings
     * @secure
     */
    tenantsSaveTenantSettings2 = (
        tenantId: string,
        data: TenantSettingsWrite,
        params: RequestParams = {},
    ) =>
        this.request<TenantsSaveTenantSettings2Data, TenantsSaveTenantSettings2Error>({
            path: `/api/financing/v1/tenants/${tenantId}/settings`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetSettings2
     * @summary Get tenant's general financing settings.
     * @request GET:/api/financing/v1/tenants/{tenantId}/settings
     * @secure
     */
    tenantsGetSettings2 = (tenantId: string, params: RequestParams = {}) =>
        this.request<TenantsGetSettings2Data, void>({
            path: `/api/financing/v1/tenants/${tenantId}/settings`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsSaveProviderPreference2
     * @summary Set the tenant's preferences for a specific financing provider.
     * @request PUT:/api/financing/v1/tenants/{tenantId}/providers/{providerName}
     * @secure
     */
    tenantsSaveProviderPreference2 = (
        tenantId: string,
        providerName: string,
        data: ProviderPreferenceWrite,
        params: RequestParams = {},
    ) =>
        this.request<TenantsSaveProviderPreference2Data, TenantsSaveProviderPreference2Error>({
            path: `/api/financing/v1/tenants/${tenantId}/providers/${providerName}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetProviderPreference2
     * @summary Get the tenant's preferences for a specific financing provider.
     * @request GET:/api/financing/v1/tenants/{tenantId}/providers/{providerName}
     * @secure
     */
    tenantsGetProviderPreference2 = (
        tenantId: string,
        providerName: string,
        params: RequestParams = {},
    ) =>
        this.request<TenantsGetProviderPreference2Data, void>({
            path: `/api/financing/v1/tenants/${tenantId}/providers/${providerName}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsUpdatePreferredProvider2
     * @summary Updates preferred provider for the tenant.
     * @request PUT:/api/financing/v1/tenants/{tenantId}/preferred-provider
     * @secure
     */
    tenantsUpdatePreferredProvider2 = (
        tenantId: string,
        data: UpdatePreferredProviderRequest,
        params: RequestParams = {},
    ) =>
        this.request<TenantsUpdatePreferredProvider2Data, TenantsUpdatePreferredProvider2Error>({
            path: `/api/financing/v1/tenants/${tenantId}/preferred-provider`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetAllProviderPreferences2
     * @summary Get the tenant's preferences for all financing providers.
     * @request GET:/api/financing/v1/tenants/{tenantId}
     * @secure
     */
    tenantsGetAllProviderPreferences2 = (
        { tenantId, ...query }: TenantsGetAllProviderPreferences2Params,
        params: RequestParams = {},
    ) =>
        this.request<TenantsGetAllProviderPreferences2Data, void>({
            path: `/api/financing/v1/tenants/${tenantId}`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Checks whether a given technician has completed training with the provider. Currently, this is applicable only to GreenSky. Pass merchantId to run the check against a specific GreenSky merchant; when omitted, the tenant's default merchant is used.
     *
     * @tags Tenants
     * @name TenantsGetTrainingStatus2
     * @summary Get technician training status.
     * @request GET:/api/financing/v1/tenants/{tenantId}/training
     * @secure
     */
    tenantsGetTrainingStatus2 = (
        { tenantId, ...query }: TenantsGetTrainingStatus2Params,
        params: RequestParams = {},
    ) =>
        this.request<TenantsGetTrainingStatus2Data, void>({
            path: `/api/financing/v1/tenants/${tenantId}/training`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetFinancingOffered2
     * @summary Return a list of financing offered job matching the filter criteria
     * @request GET:/api/financing/v1/tenants/{tenantId}/financingOffered
     * @secure
     */
    tenantsGetFinancingOffered2 = (
        { tenantId, ...query }: TenantsGetFinancingOffered2Params,
        params: RequestParams = {},
    ) =>
        this.request<TenantsGetFinancingOffered2Data, any>({
            path: `/api/financing/v1/tenants/${tenantId}/financingOffered`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsStoreFinancingOffered2
     * @request POST:/api/financing/v1/tenants/{tenantId}/financingOffered
     * @secure
     */
    tenantsStoreFinancingOffered2 = (
        tenantId: string,
        data: CreateFinancingOfferedRequest,
        params: RequestParams = {},
    ) =>
        this.request<TenantsStoreFinancingOffered2Data, void>({
            path: `/api/financing/v1/tenants/${tenantId}/financingOffered`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ImprovementsGetProviderImprovements
     * @summary Returns the list of improvements supported by the financing provider.
     * @request GET:/v2/providers/{providerName}/improvements
     * @secure
     */
    improvementsGetProviderImprovements = (
        { providerName, ...query }: ImprovementsGetProviderImprovementsParams,
        params: RequestParams = {},
    ) =>
        this.request<ImprovementsGetProviderImprovementsData, void>({
            path: `/v2/providers/${providerName}/improvements`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name LegalDisclosuresGetLegalDisclosures
     * @summary Gets legal disclosures.
     * @request GET:/v2/providers/{providerName}/disclosures
     * @secure
     */
    legalDisclosuresGetLegalDisclosures = (
        { providerName, ...query }: LegalDisclosuresGetLegalDisclosuresParams,
        params: RequestParams = {},
    ) =>
        this.request<
            LegalDisclosuresGetLegalDisclosuresData,
            LegalDisclosuresGetLegalDisclosuresError
        >({
            path: `/v2/providers/${providerName}/disclosures`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Requests the financing provider to generate documents for the loan application and makes them available for download.
     *
     * @tags Loans
     * @name LoansGenerateLoanDocuments
     * @summary Generate loan documents
     * @request POST:/v2/loans/{id}/document
     * @secure
     */
    loansGenerateLoanDocuments = (
        id: string,
        data: LoanDocumentRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansGenerateLoanDocumentsData, LoansGenerateLoanDocumentsError>({
            path: `/v2/loans/${id}/document`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description Request the financing provider to either generate a link where the user can go to fill out the loan application or to send the user an email/SMS with a link to fill out the loan application.
     *
     * @tags Loans
     * @name LoansSubmitExternalApplication
     * @summary Get a link or email for an external loan application.
     * @request POST:/v2/loans/external
     * @secure
     */
    loansSubmitExternalApplication = (
        data: ExternalApplicationRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansSubmitExternalApplicationData, LoansSubmitExternalApplicationError>({
            path: `/v2/loans/external`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description Submit a request to change an existing approved loan application. This may change the loan's status and will trigger new loan documents to be created.
     *
     * @tags Loans
     * @name LoansChangeOrder
     * @summary Request to change loan application terms.
     * @request POST:/v2/loans/external/{id}/changeorder
     * @secure
     */
    loansChangeOrder = (id: string, data: ChangeExternalOrderRequest, params: RequestParams = {}) =>
        this.request<LoansChangeOrderData, LoansChangeOrderError>({
            path: `/v2/loans/external/${id}/changeorder`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateLoanApplication
     * @summary Updates an existing loan application record.
     * @request PATCH:/v2/loans/{id}
     * @secure
     */
    loansUpdateLoanApplication = (
        { id, ...query }: LoansUpdateLoanApplicationParams,
        data: LoansUpdateLoanApplicationPayload,
        params: RequestParams = {},
    ) =>
        this.request<LoansUpdateLoanApplicationData, LoansUpdateLoanApplicationError>({
            path: `/v2/loans/${id}`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This endpoint requires MSAL authentication.
     *
     * @tags Loans
     * @name LoansUpdateLoanApplicationAuthorized
     * @summary Updates an existing loan application record.
     * @request PATCH:/v2/loans-auth/{id}
     * @secure
     */
    loansUpdateLoanApplicationAuthorized = (
        { id, ...query }: LoansUpdateLoanApplicationAuthorizedParams,
        data: LoansUpdateLoanApplicationAuthorizedPayload,
        params: RequestParams = {},
    ) =>
        this.request<
            LoansUpdateLoanApplicationAuthorizedData,
            LoansUpdateLoanApplicationAuthorizedError
        >({
            path: `/v2/loans-auth/${id}`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description Specify loanIds to publish specific loans, tenantIds to publish all loans for given tenants, or startDate/endDate to publish loans within a date range (optionally combined with tenantIds to filter by tenant). If loanIds are specified, all other filters are ignored.
     *
     * @tags Loans
     * @name LoansPublishLoanApplications
     * @summary Publishes (or re-publishes) existing loan application records
     * @request POST:/v2/loans/publish
     * @secure
     */
    loansPublishLoanApplications = (
        data: PublishLoanApplicationsRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansPublishLoanApplicationsData, LoansPublishLoanApplicationsError>({
            path: `/v2/loans/publish`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateAuthorizationStatus
     * @summary Check/update authorization status for a specific loan, defaults to the first authorization.
     * @request POST:/v2/loans/{loanId}/authorization-status
     * @secure
     */
    loansUpdateAuthorizationStatus = (loanId: string, params: RequestParams = {}) =>
        this.request<LoansUpdateAuthorizationStatusData, void>({
            path: `/v2/loans/${loanId}/authorization-status`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateAuthorizationStatusByAuthorizationId
     * @summary Check/update authorization status for a specific authorization by ID.
     * @request POST:/v2/loans/{loanId}/authorization-status/{authorizationId}
     * @secure
     */
    loansUpdateAuthorizationStatusByAuthorizationId = (
        loanId: string,
        authorizationId: string,
        params: RequestParams = {},
    ) =>
        this.request<LoansUpdateAuthorizationStatusByAuthorizationIdData, void>({
            path: `/v2/loans/${loanId}/authorization-status/${authorizationId}`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSearchAndImport
     * @summary Search and import a loan.
     * @request POST:/v2/loans/imported
     * @secure
     */
    loansSearchAndImport = (data: ImportLoanSearchRequestDto, params: RequestParams = {}) =>
        this.request<LoansSearchAndImportData, LoansSearchAndImportError>({
            path: `/v2/loans/imported`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateProjects
     * @summary Updates projects for a Loan for GoodLeap.
     * @request PUT:/v2/loans/{id}/projects
     * @secure
     */
    loansUpdateProjects = (id: string, data: PutProjectsRequest, params: RequestParams = {}) =>
        this.request<LoansUpdateProjectsData, LoansUpdateProjectsError>({
            path: `/v2/loans/${id}/projects`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansGetProjectTypes
     * @summary Retrieves project types for a loan application from GoodLeap.
     * @request GET:/v2/loans/{id}/project-types
     * @secure
     */
    loansGetProjectTypes = (
        { id, ...query }: LoansGetProjectTypesParams,
        params: RequestParams = {},
    ) =>
        this.request<LoansGetProjectTypesData, LoansGetProjectTypesError>({
            path: `/v2/loans/${id}/project-types`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Returns the financing account settings for the specified tenant and provider. If buId is provided, returns only the account for that business unit; otherwise returns the default account and all per-BU overrides. The properties field in the response carries provider-specific settings — for example minEstimateAmount / maxEstimateAmount for Affirm.
     *
     * @tags Accounts
     * @name AccountsGet
     * @summary Get financing account settings.
     * @request GET:/v1/accounts/providers/{providerName}
     * @secure
     */
    accountsGet = ({ providerName, ...query }: AccountsGetParams, params: RequestParams = {}) =>
        this.request<AccountsGetData, AccountsGetError>({
            path: `/v1/accounts/providers/${providerName}`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Accounts
     * @name AccountsPut
     * @summary Saves financing provider account settings for a tenant.
     * @request PUT:/v1/accounts/providers/{providerName}
     * @secure
     */
    accountsPut = (
        { providerName, ...query }: AccountsPutParams,
        data: TenantAccountWrite,
        params: RequestParams = {},
    ) =>
        this.request<AccountsPutData, AccountsPutError>({
            path: `/v1/accounts/providers/${providerName}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Accounts
     * @name AccountsPutFinanceIt
     * @summary Saves Financeit account for the provided tenant.
     * @request PUT:/v1/accounts/providers/financeit
     * @secure
     */
    accountsPutFinanceIt = (
        query: AccountsPutFinanceItParams,
        data: FinanceItTenantAccountWrite,
        params: RequestParams = {},
    ) =>
        this.request<AccountsPutFinanceItData, AccountsPutFinanceItError>({
            path: `/v1/accounts/providers/financeit`,
            method: 'PUT',
            baseURL: this.baseUrl,
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
 * No description
 *
 * @tags Accounts
 * @name AccountsPublishAccounts
 * @summary Republishes every account for the given provider. Publishes a TenantAccountRead Kafka
event (consumed by financing-subscriber → provider adapters) and forwards each
non-General account directly to fin-plans so its account mirror stays in sync.
 * @request POST:/v1/accounts/providers/{providerName}/exports
 * @secure
 */
    accountsPublishAccounts = (providerName: string, params: RequestParams = {}) =>
        this.request<AccountsPublishAccountsData, AccountsPublishAccountsError>({
            path: `/v1/accounts/providers/${providerName}/exports`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description Attempts to start a new customer authentication challenge. Some providers (for now, just GreenSky) want to verify that a customer is who they say they are. This endpoint starts that process.
     *
     * @tags CustomerAuth
     * @name CustomerAuthStartChallenge
     * @summary Start a customer authentication challenge.
     * @request POST:/v1/customer-auth/providers/{providerName}/challenge
     * @secure
     */
    customerAuthStartChallenge = (
        providerName: string,
        data: AuthenticationChallengeStartRequest,
        params: RequestParams = {},
    ) =>
        this.request<CustomerAuthStartChallengeData, CustomerAuthStartChallengeError>({
            path: `/v1/customer-auth/providers/${providerName}/challenge`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags CustomerAuth
     * @name CustomerAuthCompleteChallenge
     * @summary Attempts to complete a customer authentication challenge.
     * @request POST:/v1/customer-auth/providers/{providerName}/challenge/{challengeId}/completed
     * @secure
     */
    customerAuthCompleteChallenge = (
        providerName: string,
        challengeId: string,
        data: AuthenticationChallengeCompleteRequest,
        params: RequestParams = {},
    ) =>
        this.request<CustomerAuthCompleteChallengeData, CustomerAuthCompleteChallengeError>({
            path: `/v1/customer-auth/providers/${providerName}/challenge/${challengeId}/completed`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
 * No description
 *
 * @tags Customers
 * @name CustomersFindOneCustomer
 * @summary Find an existing customer by name, phone, and/or address.
POST is used instead of GET because the request has a complex body schema.
 * @request POST:/v1/customers/find-one
 * @secure
 */
    customersFindOneCustomer = (data: FindOneCustomerRequest, params: RequestParams = {}) =>
        this.request<CustomersFindOneCustomerData, CustomersFindOneCustomerError>({
            path: `/v1/customers/find-one`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
 * No description
 *
 * @tags Customers
 * @name CustomersGetCustomerDetails
 * @summary Look up name, address, and CRM type for a batch of customer ids.
The id list is passed as repeated CustomerIds query params, e.g.
?TenantId=123&CustomerIds=1&CustomerIds=2.
 * @request GET:/v1/customers/details
 * @secure
 */
    customersGetCustomerDetails = (
        query: CustomersGetCustomerDetailsParams,
        params: RequestParams = {},
    ) =>
        this.request<CustomersGetCustomerDetailsData, CustomersGetCustomerDetailsError>({
            path: `/v1/customers/details`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Links
     * @name LinksCreateLink
     * @summary Request new link to Loan Application form in MFE for customer.
     * @request POST:/v1/links
     * @secure
     */
    linksCreateLink = (data: CreateCustomerFinancingLinkApiRequest, params: RequestParams = {}) =>
        this.request<LinksCreateLinkData, LinksCreateLinkError>({
            path: `/v1/links`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Links
     * @name LinksGetLinks
     * @summary Get Links, generated for customer to apply for financing.
     * @request GET:/v1/links
     * @secure
     */
    linksGetLinks = (query: LinksGetLinksParams, params: RequestParams = {}) =>
        this.request<LinksGetLinksData, LinksGetLinksError>({
            path: `/v1/links`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Links
     * @name LinksGetLinkByShortCode
     * @summary Get a single link by short code
     * @request GET:/v1/links/{shortCode}
     * @secure
     */
    linksGetLinkByShortCode = (shortCode: string, params: RequestParams = {}) =>
        this.request<LinksGetLinkByShortCodeData, LinksGetLinkByShortCodeError>({
            path: `/v1/links/${shortCode}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSubmitApplication22
     * @summary Submit a loan application.
     * @request POST:/v1/loans
     * @secure
     */
    loansSubmitApplication22 = (data: LoanApplication, params: RequestParams = {}) =>
        this.request<LoansSubmitApplication22Data, LoansSubmitApplication22Error>({
            path: `/v1/loans`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansGetLoansByQuery
     * @summary Return loans matching the filter criteria
     * @request GET:/v1/loans
     * @secure
     */
    loansGetLoansByQuery = (query: LoansGetLoansByQueryParams, params: RequestParams = {}) =>
        this.request<LoansGetLoansByQueryData, LoansGetLoansByQueryError>({
            path: `/v1/loans`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
 * No description
 *
 * @tags Loans
 * @name LoansSubmitPrequal
 * @summary Submit an inline soft-pull prequal (FIN-17539 REQ-LIFE-02). Creates a
LoanApplication row in prequalification-pending status, dispatches
to the resolved provider's soft-pull surface, and returns the outcome.
 * @request POST:/v1/loans/prequal
 * @secure
 */
    loansSubmitPrequal = (data: SubmitPrequalRequest, params: RequestParams = {}) =>
        this.request<LoansSubmitPrequalData, LoansSubmitPrequalError>({
            path: `/v1/loans/prequal`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description After the loan is approved, this endpoint can be used to generate the loan documents to be signed by the customer. Applicable to only Service Finance.
     *
     * @tags Loans
     * @name LoansGenerateLoanDocuments22
     * @summary Generate loan documents.
     * @request POST:/v1/loans/{id}/document
     * @secure
     */
    loansGenerateLoanDocuments22 = (id: string, params: RequestParams = {}) =>
        this.request<LoansGenerateLoanDocuments22Data, LoansGenerateLoanDocuments22Error>({
            path: `/v1/loans/${id}/document`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description This is used to clean up the documents after the loan application is completed or expired.
     *
     * @tags Loans
     * @name LoansDeleteLoanDocuments
     * @summary Delete all documents for a loan.
     * @request DELETE:/v1/loans/{LoanId}/document
     * @secure
     */
    loansDeleteLoanDocuments = (loanId: string, params: RequestParams = {}) =>
        this.request<LoansDeleteLoanDocumentsData, void>({
            path: `/v1/loans/${loanId}/document`,
            method: 'DELETE',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansDeleteAllDocuments
     * @summary Delete loan documents for all loans.
     * @request DELETE:/v1/loans/document/cleanup
     * @secure
     */
    loansDeleteAllDocuments = (params: RequestParams = {}) =>
        this.request<LoansDeleteAllDocumentsData, void>({
            path: `/v1/loans/document/cleanup`,
            method: 'DELETE',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdateStatusFromProvider
     * @summary Re-query the provider for the status of the loan application.
     * @request POST:/v1/loans/{id}/status
     * @secure
     */
    loansUpdateStatusFromProvider = (id: string, params: RequestParams = {}) =>
        this.request<LoansUpdateStatusFromProviderData, LoansUpdateStatusFromProviderError>({
            path: `/v1/loans/${id}/status`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSignLoanDocument
     * @summary Submit a loan application signature.
     * @request POST:/v1/loans/{id}/signInfo
     * @secure
     */
    loansSignLoanDocument = (
        id: string,
        data: SignLoanDocumentRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansSignLoanDocumentData, LoansSignLoanDocumentError>({
            path: `/v1/loans/${id}/signInfo`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This should usually be called after creating the loan documents using POST /v1/loans/{id}/document.
     *
     * @tags Loans
     * @name LoansGetDocumentFile
     * @summary Get the loan documents for the specific loan.
     * @request GET:/v1/loans/{id}/documentfile
     * @secure
     */
    loansGetDocumentFile = (id: string, params: RequestParams = {}) =>
        this.request<LoansGetDocumentFileData, void>({
            path: `/v1/loans/${id}/documentfile`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description ⚠️ DEPRECATED: This GET endpoint performs state-changing operations, which violates REST principles. Use PUT /v1/loans/{id}/refresh instead.
     *
     * @tags Loans
     * @name LoansGetLoanByIdOrExternalId
     * @summary Re-query the provider for loan details.
     * @request GET:/v1/loans/{id}
     * @deprecated
     * @secure
     */
    loansGetLoanByIdOrExternalId = (id: string, params: RequestParams = {}) =>
        this.request<LoansGetLoanByIdOrExternalIdData, void>({
            path: `/v1/loans/${id}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description This is a GreenSky-specific action that changes an existing loan application's plan and amount. After this action, the loan application status (approved/declined/counter-offer/etc) may change.
     *
     * @tags Loans
     * @name LoansRecalculateOffer
     * @summary Recalculate offers for a loan.
     * @request PATCH:/v1/loans/{id}
     * @secure
     */
    loansRecalculateOffer = (id: string, data: RecalculateOfferData, params: RequestParams = {}) =>
        this.request<LoansRecalculateOfferData, LoansRecalculateOfferError>({
            path: `/v1/loans/${id}`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This endpoint queries the financing provider for the latest loan details and updates the local record if necessary. This may change the loan status, available credit, and other loan properties.
     *
     * @tags Loans
     * @name LoansRefreshLoanFromProvider
     * @summary Refresh loan application details from the financing provider.
     * @request PUT:/v1/loans/{id}/refresh
     * @secure
     */
    loansRefreshLoanFromProvider = (id: string, params: RequestParams = {}) =>
        this.request<LoansRefreshLoanFromProviderData, void>({
            path: `/v1/loans/${id}/refresh`,
            method: 'PUT',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansGetAvailableCreditForLoans
     * @summary Get the available credit for the customer.
     * @request GET:/v1/loans/provider/{providerName}/tenant/{tenantId}/customer/{customerId}/availablecredit
     * @secure
     */
    loansGetAvailableCreditForLoans = (
        providerName: string,
        tenantId: string,
        customerId: string,
        params: RequestParams = {},
    ) =>
        this.request<LoansGetAvailableCreditForLoansData, void>({
            path: `/v1/loans/provider/${providerName}/tenant/${tenantId}/customer/${customerId}/availablecredit`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description This endpoint returns loans that were created through the prequalification flow (without a job). It validates that the requesting business unit's merchant ID matches the prequalification business unit's merchant ID. If no provider name is specified, it checks both GoodLeap and Synchrony providers.
     *
     * @tags Loans
     * @name LoansGetLoansWithNoJob
     * @summary Get loans for a customer that were created without a job ID.
     * @request GET:/v1/loans/withNoJob
     * @secure
     */
    loansGetLoansWithNoJob = (query: LoansGetLoansWithNoJobParams, params: RequestParams = {}) =>
        this.request<LoansGetLoansWithNoJobData, LoansGetLoansWithNoJobError>({
            path: `/v1/loans/withNoJob`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Request the financing provider to either generate a link where the user can go to fill out the loan application or to send the user an email/SMS with a link to fill out the loan application.
     *
     * @tags Loans
     * @name LoansSubmitExternalApplication22
     * @summary Get a link or email for an external loan application.
     * @request POST:/v1/loans/external
     * @secure
     */
    loansSubmitExternalApplication22 = (
        data: ExternalApplicationRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansSubmitExternalApplication22Data, LoansSubmitExternalApplication22Error>({
            path: `/v1/loans/external`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansObtainExternalFundingAccessLink
     * @summary Submit request to Financeit for obtaining the external funding status access link.
     * @request GET:/v1/loans/externalfunding
     * @secure
     */
    loansObtainExternalFundingAccessLink = (
        query: LoansObtainExternalFundingAccessLinkParams,
        params: RequestParams = {},
    ) =>
        this.request<
            LoansObtainExternalFundingAccessLinkData,
            LoansObtainExternalFundingAccessLinkError
        >({
            path: `/v1/loans/externalfunding`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description This endpoint is applicable only to Financeit. It submits a letter of completion that indicates that the job is complete and that the loan funds can now be released to the tenant.
     *
     * @tags Loans
     * @name LoansProcessLoc
     * @summary Submit a letter of completion to the provider.
     * @request PUT:/v1/loans/loc/tenants/{tenantId}/jobs/{jobId}
     * @secure
     */
    loansProcessLoc = (
        tenantId: string,
        jobId: string,
        data: LocCreated,
        params: RequestParams = {},
    ) =>
        this.request<LoansProcessLocData, LoansProcessLocError>({
            path: `/v1/loans/loc/tenants/${tenantId}/jobs/${jobId}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This is a GreenSky-specific action that sets up a customer GreenSky account associated with the loan.
     *
     * @tags Loans
     * @name LoansCreateAccount
     * @summary Create an account for the customer with the provider.
     * @request POST:/v1/loans/{id}/account
     * @secure
     */
    loansCreateAccount = (id: string, params: RequestParams = {}) =>
        this.request<LoansCreateAccountData, LoansCreateAccountError>({
            path: `/v1/loans/${id}/account`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description This is a GreenSky-specific action that activates the customer's GreenSky account.
     *
     * @tags Loans
     * @name LoansActiveAccount
     * @summary Activate customer's account with the provider.
     * @request POST:/v1/loans/{id}/activation
     * @secure
     */
    loansActiveAccount = (id: string, params: RequestParams = {}) =>
        this.request<LoansActiveAccountData, LoansActiveAccountError>({
            path: `/v1/loans/${id}/activation`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansPutLoanApplication
     * @summary Imports a loan application that was created in a different system.
     * @request PUT:/v1/loans/{externalId}
     * @secure
     */
    loansPutLoanApplication = (
        externalId: string,
        data: ImportLoanApplicationRequest,
        params: RequestParams = {},
    ) =>
        this.request<LoansPutLoanApplicationData, LoansPutLoanApplicationError>({
            path: `/v1/loans/${externalId}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description A loan may require update if it is in a non-terminal status (e.g. submitted) and has not been updated for a while.
     *
     * @tags Loans
     * @name LoansGetLoansRequiringUpdate
     * @summary Finds loans that may require an update from the provider.
     * @request GET:/v1/loans/provider/{providerName}/outdated
     * @secure
     */
    loansGetLoansRequiringUpdate = (
        { providerName, ...query }: LoansGetLoansRequiringUpdateParams,
        params: RequestParams = {},
    ) =>
        this.request<LoansGetLoansRequiringUpdateData, any>({
            path: `/v1/loans/provider/${providerName}/outdated`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description This endpoint supports GoodLeap and Synchrony.
     *
     * @tags Loans
     * @name LoansAuthorizeLoan
     * @summary Authorize the sales slip.
     * @request POST:/v1/loans/{id}/authorization
     * @secure
     */
    loansAuthorizeLoan = (id: string, data: AuthorizeLoanRequestDto, params: RequestParams = {}) =>
        this.request<LoansAuthorizeLoanData, LoansAuthorizeLoanError>({
            path: `/v1/loans/${id}/authorization`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansSendSalesSlip
     * @summary Send the sales slip for a loan payment to the homeowner.
     * @request POST:/v1/loans/{id}/salesSlip
     * @secure
     */
    loansSendSalesSlip = (id: string, data: SendSalesSlipRequestDto, params: RequestParams = {}) =>
        this.request<LoansSendSalesSlipData, LoansSendSalesSlipError>({
            path: `/v1/loans/${id}/salesSlip`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * @description This is a Synchrony-specific endpoint.
     *
     * @tags Loans
     * @name LoansVoidAuthorization
     * @summary Void a sales slip authorization for a loan.
     * @request DELETE:/v1/loans/{loanId}/authorizations/{authorizationId}
     * @secure
     */
    loansVoidAuthorization = (
        loanId: string,
        authorizationId: string,
        params: RequestParams = {},
    ) =>
        this.request<LoansVoidAuthorizationData, LoansVoidAuthorizationError>({
            path: `/v1/loans/${loanId}/authorizations/${authorizationId}`,
            method: 'DELETE',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUploadSingleFile
     * @request POST:/v1/loans/{loanId}/files
     * @secure
     */
    loansUploadSingleFile = (
        loanId: string,
        data: LoansUploadSingleFilePayload,
        params: RequestParams = {},
    ) =>
        this.request<LoansUploadSingleFileData, any>({
            path: `/v1/loans/${loanId}/files`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.FormData,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersGetProviders
     * @summary List all available financing providers.
     * @request GET:/v1/providers
     * @secure
     */
    providersGetProviders = (params: RequestParams = {}) =>
        this.request<ProvidersGetProvidersData, void>({
            path: `/v1/providers`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersTouchProvider
     * @summary Check whether the financing provider is supported by ServiceTitan.
     * @request HEAD:/v1/providers/{providerName}
     * @secure
     */
    providersTouchProvider = (providerName: string, params: RequestParams = {}) =>
        this.request<ProvidersTouchProviderData, void>({
            path: `/v1/providers/${providerName}`,
            method: 'HEAD',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersGetProviderImprovements
     * @summary List all improvements supported by this financing provider.
     * @request GET:/v1/providers/{providerName}/improvements
     * @secure
     */
    providersGetProviderImprovements = (
        { providerName, ...query }: ProvidersGetProviderImprovementsParams,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetProviderImprovementsData, void>({
            path: `/v1/providers/${providerName}/improvements`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersGetLegalDisclosures
     * @summary Gets Legal Disclosures for the specified provider and disclosure type.
     * @request GET:/v1/providers/{providerName}/disclosures
     * @secure
     */
    providersGetLegalDisclosures = (
        { providerName, ...query }: ProvidersGetLegalDisclosuresParams,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetLegalDisclosuresData, void>({
            path: `/v1/providers/${providerName}/disclosures`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Currently, this applies only to GoodLeap.
     *
     * @tags Providers
     * @name ProvidersGetOperatingStates
     * @summary Get the list of US states in which the provider allows the tenant to offer loans
     * @request GET:/v1/providers/{providerName}/states
     * @secure
     */
    providersGetOperatingStates = (
        { providerName, ...query }: ProvidersGetOperatingStatesParams,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetOperatingStatesData, void>({
            path: `/v1/providers/${providerName}/states`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Currently, this applies only to GoodLeap.
     *
     * @tags Providers
     * @name ProvidersGetUsers
     * @summary List tenant's users (technicians) registered with the provider.
     * @request GET:/v1/providers/{providerName}/users
     * @secure
     */
    providersGetUsers = (
        { providerName, ...query }: ProvidersGetUsersParams,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetUsersData, void>({
            path: `/v1/providers/${providerName}/users`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Providers
     * @name ProvidersResyncPlans
     * @summary Force-resync cached plans from the provider.
     * @request POST:/v1/providers/{providerName}/resync-plans
     * @secure
     */
    providersResyncPlans = (
        { providerName, ...query }: ProvidersResyncPlansParams,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersResyncPlansData, void>({
            path: `/v1/providers/${providerName}/resync-plans`,
            method: 'POST',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
 * No description
 *
 * @tags Providers
 * @name ProvidersGetLogo
 * @summary Return a provider's logo. The file type may be different depending on the provider, so you would
need to check the response's content type to determine how to display it.
 * @request GET:/v1/providers/{providerName}/logo
 * @secure
 */
    providersGetLogo = (providerName: string, params: RequestParams = {}) =>
        this.request<ProvidersGetLogoData, ProvidersGetLogoError>({
            path: `/v1/providers/${providerName}/logo`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
 * No description
 *
 * @tags Providers
 * @name ProvidersGetFinancingEligibility
 * @summary Read-only financing eligibility check, called by the MFE on page load to decide whether to render the
financing card and what amount to prefill. Creates no records and performs no writes.
 * @request GET:/v1/providers/eligibility
 * @secure
 */
    providersGetFinancingEligibility = (
        query: ProvidersGetFinancingEligibilityParams,
        params: RequestParams = {},
    ) =>
        this.request<ProvidersGetFinancingEligibilityData, ProvidersGetFinancingEligibilityError>({
            path: `/v1/providers/eligibility`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Status
     * @name StatusGet
     * @summary An easy way to run health checks
     * @request GET:/v1/status
     * @secure
     */
    statusGet = (params: RequestParams = {}) =>
        this.request<StatusGetData, any>({
            path: `/v1/status`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Status
     * @name StatusMetrics
     * @request GET:/v1/status/metrics
     * @secure
     */
    statusMetrics = (params: RequestParams = {}) =>
        this.request<StatusMetricsData, any>({
            path: `/v1/status/metrics`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * @description This endpoint completes the OAuth flow for a technician. Some providers (for now, only Financeit) require a technician to authenticate before they can view customer data. This endpoint is called by the provider's OAuth callback to complete the authentication process.
     *
     * @tags TechnicianAuth
     * @name TechnicianAuthOAuthTokenExistenceCheck
     * @summary Complete technician authentication with a provider.
     * @request HEAD:/v1/technician-auth/{providerName}/oauth/token
     * @secure
     */
    technicianAuthOAuthTokenExistenceCheck = (providerName: string, params: RequestParams = {}) =>
        this.request<TechnicianAuthOAuthTokenExistenceCheckData, void>({
            path: `/v1/technician-auth/${providerName}/oauth/token`,
            method: 'HEAD',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Telemetry
     * @name TelemetryGet
     * @request GET:/v1/telemetry
     * @secure
     */
    telemetryGet = (params: RequestParams = {}) =>
        this.request<TelemetryGetData, any>({
            path: `/v1/telemetry`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsSaveTenantSettings
     * @summary Updates tenant's general financing settings.
     * @request PUT:/v1/tenants/{tenantId}/settings
     * @secure
     */
    tenantsSaveTenantSettings = (
        tenantId: string,
        data: TenantSettingsWrite,
        params: RequestParams = {},
    ) =>
        this.request<TenantsSaveTenantSettingsData, TenantsSaveTenantSettingsError>({
            path: `/v1/tenants/${tenantId}/settings`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetSettings
     * @summary Get tenant's general financing settings.
     * @request GET:/v1/tenants/{tenantId}/settings
     * @secure
     */
    tenantsGetSettings = (tenantId: string, params: RequestParams = {}) =>
        this.request<TenantsGetSettingsData, void>({
            path: `/v1/tenants/${tenantId}/settings`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsSaveProviderPreference
     * @summary Set the tenant's preferences for a specific financing provider.
     * @request PUT:/v1/tenants/{tenantId}/providers/{providerName}
     * @secure
     */
    tenantsSaveProviderPreference = (
        tenantId: string,
        providerName: string,
        data: ProviderPreferenceWrite,
        params: RequestParams = {},
    ) =>
        this.request<TenantsSaveProviderPreferenceData, TenantsSaveProviderPreferenceError>({
            path: `/v1/tenants/${tenantId}/providers/${providerName}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetProviderPreference
     * @summary Get the tenant's preferences for a specific financing provider.
     * @request GET:/v1/tenants/{tenantId}/providers/{providerName}
     * @secure
     */
    tenantsGetProviderPreference = (
        tenantId: string,
        providerName: string,
        params: RequestParams = {},
    ) =>
        this.request<TenantsGetProviderPreferenceData, void>({
            path: `/v1/tenants/${tenantId}/providers/${providerName}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsUpdatePreferredProvider
     * @summary Updates preferred provider for the tenant.
     * @request PUT:/v1/tenants/{tenantId}/preferred-provider
     * @secure
     */
    tenantsUpdatePreferredProvider = (
        tenantId: string,
        data: UpdatePreferredProviderRequest,
        params: RequestParams = {},
    ) =>
        this.request<TenantsUpdatePreferredProviderData, TenantsUpdatePreferredProviderError>({
            path: `/v1/tenants/${tenantId}/preferred-provider`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetAllProviderPreferences
     * @summary Get the tenant's preferences for all financing providers.
     * @request GET:/v1/tenants/{tenantId}
     * @secure
     */
    tenantsGetAllProviderPreferences = (
        { tenantId, ...query }: TenantsGetAllProviderPreferencesParams,
        params: RequestParams = {},
    ) =>
        this.request<TenantsGetAllProviderPreferencesData, void>({
            path: `/v1/tenants/${tenantId}`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @description Checks whether a given technician has completed training with the provider. Currently, this is applicable only to GreenSky. Pass merchantId to run the check against a specific GreenSky merchant; when omitted, the tenant's default merchant is used.
     *
     * @tags Tenants
     * @name TenantsGetTrainingStatus
     * @summary Get technician training status.
     * @request GET:/v1/tenants/{tenantId}/training
     * @secure
     */
    tenantsGetTrainingStatus = (
        { tenantId, ...query }: TenantsGetTrainingStatusParams,
        params: RequestParams = {},
    ) =>
        this.request<TenantsGetTrainingStatusData, void>({
            path: `/v1/tenants/${tenantId}/training`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetFinancingOffered
     * @summary Return a list of financing offered job matching the filter criteria
     * @request GET:/v1/tenants/{tenantId}/financingOffered
     * @secure
     */
    tenantsGetFinancingOffered = (
        { tenantId, ...query }: TenantsGetFinancingOfferedParams,
        params: RequestParams = {},
    ) =>
        this.request<TenantsGetFinancingOfferedData, any>({
            path: `/v1/tenants/${tenantId}/financingOffered`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsStoreFinancingOffered
     * @request POST:/v1/tenants/{tenantId}/financingOffered
     * @secure
     */
    tenantsStoreFinancingOffered = (
        tenantId: string,
        data: CreateFinancingOfferedRequest,
        params: RequestParams = {},
    ) =>
        this.request<TenantsStoreFinancingOfferedData, void>({
            path: `/v1/tenants/${tenantId}/financingOffered`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });
}
